import React, {useEffect, useState} from "react";

export default function OpticaFront({
  lightContrast,
  darkContrast,
  stitching,
  patchColor,
  azomo,
  printStyle,
  getDataFromChild,
  preview,
}) {
  function adjust(color, amount) {
    return (
      "#" +
      color
        .replace(/^#/, "")
        .replace(/../g, (color) =>
          (
            "0" + Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)
          ).substr(-2)
        )
    );
  }

  const [darkenColor, setDarkenColor] = useState(lightContrast);

  const [lightContrastActive, setLightContrastActive] = useState(false);
  const [darkContrastActive, setDarkContrastActive] = useState(false);
  const [stitchingActive, setStitchingActive] = useState(false);
  const [patchActive, setPatchActive] = useState(false);
  const [azomoActive, setAzomoActive] = useState(false);

  const handleClick = (tabId) => {
    if (!preview) {
      getDataFromChild(tabId);
    }
  };

  useEffect(() => {
    setDarkenColor(adjust(lightContrast, -150));
  }, lightContrast);

  return (
    <svg
      className={printStyle}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 500 500"
      enableBackground="new 0 0 500 500"
    >
      <path
        fill={lightContrast}
        onClick={() => handleClick("base")}
        onMouseEnter={() => setLightContrastActive(true)}
        onMouseLeave={() => setLightContrastActive(false)}
        style={
          lightContrastActive && !preview
            ? {fill: adjust(lightContrast, 55)}
            : {fill: lightContrast}
        }
        d="M464.48,186.492c-0.278-12.299-0.549-24.126-0.782-34.854c-0.093-4.487-0.182-8.784-0.263-12.842
   c-0.829-42-5.939-71.109-10.077-88.132c-0.875-3.593-1.227-7.359-1.042-11.2c0.276-5.78-0.27-11.389-0.778-15.075
   c-0.008-0.058-0.766-5.354-1.219-6.678l-0.004-0.016c-0.054-0.151-0.104-0.247-0.147-0.275l-0.093-0.058v-0.004h-0.008l-0.057-0.038
   l-0.036,0.019c-46.131-9.14-90.122-8.652-118.914-6.631c-29.999,2.105-50.166,6.267-51.873,6.627l-0.023-0.011l-0.046,0.027
   c-0.027,0.003-0.047,0.007-0.051,0.011l0.004,0.016l-0.065,0.039c-0.047,0.027-0.093,0.124-0.148,0.278l-0.011,0.028
   c-0.422,1.238-1.092,5.779-1.099,5.834c-0.477,3.256-1.03,8.254-0.965,13.581c0.07,5.772-0.518,11.432-1.75,16.817
   c-3.809,16.647-8.513,44.873-9.303,84.841c-0.27,13.76-0.646,30.24-1.045,47.684c-1.432,62.709-3.054,133.789-1.389,142.127
   c0.828,4.127,0.968,27.464,1.13,54.486c0.255,43.12,0.581,96.785,3.767,105.411l0.054,0.147l0.151,0.046
   c0.306,0.097,31.196,9.369,72.499,0.016c0.284-0.004,0.287-0.066,0.38-1.61c0.05-0.853,0.12-2.107,0.209-3.702
   c0.174-3.186,0.418-7.738,0.704-13.201c0.508-9.663,1.2-23.139,2.064-40.057c1.487-29.133,2.954-58.265,2.954-58.265
   c0.039-0.863,3.651-86.754,2.749-122.329c1.204-27.103,7.553-53.363,7.615-53.626l0.012-0.062
   c0.607-15.923,2.972-39.682,6.999-39.961c3.96,0.275,6.314,23.264,6.969,39.171c0,0.062-0.004,0.101-0.004,0.113h0.011
   c0.008,0.228,0.016,0.452,0.027,0.677l0.008,0.062c0.062,0.263,6.411,26.523,7.619,53.607
   c-0.906,35.594,2.706,121.485,2.745,122.348c0,0,1.467,29.132,2.954,58.265c0.863,16.918,1.556,30.394,2.063,40.057
   c0.287,5.463,0.531,10.015,0.705,13.201c0.088,1.595,0.159,2.849,0.209,3.702c0.096,1.544,0.1,1.606,0.379,1.61
   c13.825,3.128,26.485,4.173,37.216,4.173c21.339,0,35.082-4.123,35.283-4.189l0.152-0.046l0.057-0.147
   c3.187-8.626,3.508-62.287,3.768-105.403c0.158-27.026,0.302-50.367,1.126-54.494C467.539,320.269,465.913,249.197,464.48,186.492z"
      />
      <path
        fill={lightContrast}
        onClick={() => handleClick("base")}
        onMouseEnter={() => setLightContrastActive(true)}
        onMouseLeave={() => setLightContrastActive(false)}
        style={
          lightContrastActive && !preview
            ? {fill: adjust(lightContrast, 55)}
            : {fill: lightContrast}
        }
        d="M234.349,483.923c-0.445-9.055-7.382-63.94-7.452-64.486c-0.043-0.433-4.549-43.685-7.453-61.996
   c-1.849-11.681-5.45-26.245-8.144-36.403c-1.472-5.544-2.176-11.266-2.099-17.007c0.147-10.325,0.256-23.442-0.027-27.29
   c-0.329-4.417-1.332-19.779-0.488-32.036c0.135-1.997,0.322-4.436,0.535-7.255c0.987-13.031,2.643-34.842,2.55-54.168
   c-0.092-18.703,0.891-31.316,1.321-35.869c0.077-0.855,0.232-1.703,0.457-2.528c2.144-7.839,11.502-49.376-14.681-97.443
   l-4.034-8.13l-2.847-8.945l-2.029-10.403c-0.205,0.012-1.952-1.019-2.195-0.973c-25.239,4.742-48.254,10.07-70.364,16.295
   c-2.98,0.84-5.989,1.665-8.896,2.462c-7.151,1.963-14.545,3.988-21.865,6.334c-0.361,0.135-0.601,0.484-0.601,0.867v19.76
   l0.012-0.004c0.081,3.035,0.6,22.303,1.08,37.788l0.008,0.237c-0.279,0.472-0.558,0.948-0.832,1.424
   c-0.832,1.433-1.654,2.869-2.474,4.305c-1.235,2.172-2.524,4.46-3.825,6.798c-1.646,2.955-3.307,5.974-4.937,8.978
   c-1.951,3.589-3.902,7.24-5.806,10.848c-2.18,4.13-4.344,8.308-6.435,12.408c-2.334,4.579-4.63,9.175-6.821,13.658
   c-2.405,4.92-4.746,9.834-6.961,14.603c-2.401,5.165-4.711,10.286-6.867,15.23c-2.316,5.308-4.511,10.542-6.528,15.551
   c-2.148,5.347-4.15,10.581-5.942,15.563c-1.937,5.362-3.612,10.356-5.126,15.269c-1.599,5.192-2.927,9.989-4.058,14.661l-0.15,0.624
   c-1.123,4.63-2.28,9.418-2.718,14.169c-0.224,2.435-0.194,4.901-0.159,7.282c0.012,0.786,0.019,1.575,0.023,2.362l0.012,4.92
   c0.012,4.011,0.027,8.021,0.046,12.032c0.023,4.719,0.051,9.443,0.086,14.162c0.034,5.106,0.077,10.209,0.131,15.315
   c0.054,5.513,0.116,10.585,0.186,15.501c0.077,5.385,0.159,10.201,0.251,14.723c0.105,4.979,0.209,9.102,0.329,12.97
   c0.097,3.027,0.221,6.608,0.419,10.254l0.011,0.221c0.112,2.087,0.229,4.247,0.504,6.361c0.042,0.31,0.093,0.682,0.162,1.045
   c1.947,10.062,1.955,30.917,1.015,39.535c-0.899,8.176,1.219,33.898,1.238,34.157l0.016,0.178l0.159,0.082
   c0.104,0.05,10.116,5.017,25.946,5.017c0.503,0,1.014-0.008,1.529-0.016c15.78-0.317,26.326-0.758,36.84-2.16
   c9.989-1.335,10.72-3.705,10.771-3.972l0.008-0.058c0-0.368,0.123-36.751,1.238-52.364c0.65-9.071,1.212-18.835,1.726-29.853
   c0.372-7.947,0.744-16.418,0.864-24.939c0.05-3.609,0.004-7.24-0.042-10.751c-0.101-7.619-0.205-15.497,0.716-23.325
   c1.765-15.056,4.846-30.151,7.824-44.75c0.36-1.761,0.719-3.523,1.076-5.284c0.879-4.344,2.276-8.962,5.896-10.654
   c0.647,3.29,5.029,25.671,5.803,32.268c0.775,6.581,5.517,43.863,6.531,51.753c1.007,7.828,12.776,61.315,12.896,61.861
   c0.097,0.398,9.605,39.91,11.057,56.626c1.467,16.942,4.966,32.381,5.606,33.147c0.456,0.55,8.881,3.09,21.853,3.516
   c1.173,0.039,2.417,0.062,3.721,0.062c12.125,0,29.74-1.89,50.2-9.807l0.217-0.085L234.349,483.923z"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M210.742,490.545c-12.211,2.559-22.528,3.039-30.065,2.818c-13.546-0.391-21.227-2.977-21.828-3.318
   c-0.565-1.021-3.995-16-5.451-32.771c-0.851-9.821-4.47-27.467-7.344-40.479c11.68-0.639,24.24-1.839,39.489-3.775
   c5.079-0.646,9.915-1.359,14.533-2.133C205.852,451.254,210.285,486.852,210.742,490.545"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M233.699,483.731c-7.933,3.058-15.428,5.199-22.33,6.678c-0.492-3.964-4.909-39.43-10.662-79.627
   c8.73-1.483,16.685-3.201,24.057-5.203c0.886,8.084,1.483,13.782,1.498,13.941C226.332,420.069,233.153,474.041,233.699,483.731"
      />
      <path
        fill="#E5E5E5"
        d="M224.694,404.936c-7.375,2.005-15.338,3.729-24.076,5.211c-1.39-9.682-2.854-19.628-4.356-29.465
   c9.094-1.525,17.352-3.31,24.983-5.393C222.491,385.289,223.75,396.365,224.694,404.936"
      />
      <path
        fill="#E5E5E5"
        d="M199.987,410.256c-4.619,0.774-9.446,1.483-14.525,2.125c-15.277,1.944-27.855,3.144-39.547,3.783
   c-1.967-8.877-3.546-15.447-3.585-15.606c-0.038-0.174-1.305-5.919-3.028-13.863c12.997-0.705,28.816-2.153,42.37-3.872
   c4.87-0.623,9.511-1.296,13.96-2.036C197.133,390.628,198.597,400.574,199.987,410.256"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M62.862,461.935c-4.038,0.143-8.424,0.255-13.317,0.352c-15.424,0.306-25.629-4.204-27.011-4.854
   c-0.191-2.331-2.079-26.098-1.228-33.852c0.446-4.057,0.728-11.734,0.589-19.706c8.858,0.604,17.27,0.794,24.378,0.794
   c6.76,0,12.33-0.17,15.97-0.325C62.188,432.613,62.789,458.76,62.862,461.935"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M97.976,401.549c-0.065,0.933-0.132,1.862-0.197,2.78c-1.096,15.365-1.236,50.784-1.242,52.356
   c-0.102,0.233-1.244,2.25-10.221,3.45c-7.058,0.94-14.135,1.448-22.811,1.773c-0.077-3.206-0.677-29.349-0.623-57.591
   c2.517-0.112,3.956-0.209,4.007-0.213C67.106,404.092,88.46,403.113,97.976,401.549"
      />
      <path
        fill="#E5E5E5"
        d="M99.672,370.887c-0.059,1.212-0.112,2.416-0.167,3.604c-0.449,9.636-0.937,18.312-1.486,26.399
   c-9.397,1.572-30.941,2.563-31.165,2.575c-0.054,0.004-1.479,0.097-3.968,0.209c0.023-9.965,0.128-20.174,0.367-29.713
   c0.585-0.031,0.906-0.054,0.93-0.054C64.442,373.891,90.082,372.467,99.672,370.887"
      />
      <path
        fill="#E5E5E5"
        d="M62.61,374c-0.236,9.535-0.341,19.74-0.363,29.701c-7.453,0.318-23.071,0.713-40.364-0.464
   c-0.139-7.066-0.612-14.294-1.599-19.381c-0.066-0.348-0.116-0.704-0.154-1.01c-0.272-2.087-0.388-4.235-0.5-6.31l-0.011-0.221
   c-0.047-0.879-0.09-1.75-0.128-2.613c8.741,0.585,17.046,0.77,24.072,0.77C52.68,374.472,59.645,374.159,62.61,374"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M195.535,380.155c-4.44,0.736-9.078,1.413-13.944,2.029c-13.577,1.726-29.423,3.174-42.423,3.875
   c-1.754-8.091-3.953-18.304-5.82-27.255c12.292-0.673,27.329-2.075,41.355-3.859c5.4-0.685,10.96-1.534,16.415-2.49
   C192.604,361.36,194.087,370.705,195.535,380.155"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M221.234,375.204l-0.147-0.535c-7.608,2.079-15.85,3.856-24.92,5.378c-1.449-9.45-2.931-18.796-4.417-27.704
   c9.058-1.602,17.812-3.507,25.075-5.486c0.763,3.678,1.451,7.317,1.989,10.689C219.549,362.196,220.389,368.448,221.234,375.204"
      />
      <path
        fill="#E5E5E5"
        d="M216.693,346.231c-7.251,1.974-15.993,3.879-25.048,5.482c-1.769-10.554-3.539-20.48-5.265-29.225
   c8.671-1.448,16.229-3.082,23.429-5.041c0.256,1.262,0.538,2.516,0.871,3.763C212.24,327.102,214.699,336.746,216.693,346.231"
      />
      <path
        fill="#E5E5E5"
        d="M191.014,351.825c-5.447,0.956-10.999,1.8-16.392,2.485c-14.045,1.789-29.109,3.19-41.405,3.86
   c-1.9-9.113-3.433-16.805-3.77-19.411c-0.248-1.924-0.716-5.594-1.297-10.143c13.201-0.716,29.523-2.191,42.682-3.868
   c5.366-0.681,10.302-1.393,14.916-2.152C187.475,331.337,189.244,341.267,191.014,351.825"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M100.364,349.572c-0.097,7.011-0.367,13.983-0.666,20.662c-9.442,1.583-35.287,3.02-35.555,3.035
   c-0.027,0-0.329,0.019-0.875,0.054c0.264-10.255,0.686-19.701,1.328-27.2c1.197-0.051,1.867-0.09,1.905-0.09
   c0.244-0.011,24.27-1.056,33.875-2.62C100.391,345.457,100.395,347.52,100.364,349.572"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M63.954,346.149c-0.643,7.515-1.061,16.961-1.324,27.208c-5.184,0.283-23.008,1.057-43.17-0.298
   c-0.109-2.485-0.19-4.874-0.256-6.984c-0.123-3.867-0.228-7.987-0.332-12.965c-0.047-2.373-0.094-4.836-0.14-7.41
   c9.303,0.627,18.54,0.821,26.38,0.821C53.601,346.521,60.45,346.293,63.954,346.149"
      />
      <path
        fill="#E5E5E5"
        d="M101.042,315.434c-0.922,7.87-0.816,15.768-0.72,23.406c0.019,1.293,0.034,2.606,0.046,3.922
   c-9.492,1.568-33.65,2.621-33.897,2.632c-0.039,0-0.678,0.036-1.817,0.086c0.237-2.649,0.5-5.045,0.794-7.128
   c1.135-7.994,2.002-15.717,2.66-22.751c8.176-0.465,25.768-1.561,33.251-2.746C101.251,313.715,101.143,314.574,101.042,315.434"
      />
      <path
        fill="#E5E5E5"
        d="M67.462,315.635c-0.658,7.003-1.518,14.68-2.645,22.625c-0.301,2.117-0.569,4.552-0.809,7.247
   c-6.658,0.274-25.837,0.863-45.283-0.45c-0.039-2.132-0.071-4.343-0.105-6.662c-0.07-4.917-0.132-9.985-0.186-15.501
   c-0.027-2.47-0.042-4.944-0.062-7.414c9.419,0.647,18.386,0.844,25.822,0.844c11.591,0,19.474-0.48,19.601-0.488
   C63.858,315.832,65.239,315.763,67.462,315.635"
      />
      <polygon
        fill="#E5E5E5"
        points="171.169,153.478 121.096,159.424 120.938,158.054 171.037,152.328 "
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M175.021,186.396c-0.209,0.34-1.157,1.525-2.075,2.675c-1.343,1.68-2.726,3.414-3.077,4.034l-39.427,4.661
   c-0.43-0.546-1.851-1.858-3.225-3.136c-0.999-0.921-2.033-1.878-2.257-2.156l-3.791-32.415l50.074-5.943L175.021,186.396z"
      />
      <path
        fill="#E5E5E5"
        d="M207.359,67.587l-33.069,3.322l-0.085-0.895l32.856-3.22C207.161,67.061,207.262,67.324,207.359,67.587"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M214.873,96.882l-30.294,3.031c-0.727-0.538-5.501-4.15-7.336-5.536l-0.004-0.038l-0.039,0.003
   c-0.271-0.205-0.476-0.36-0.585-0.441l-2.261-22.35l33.233-3.336C211.322,78.4,213.591,88.055,214.873,96.882"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M159.725,119.808c-17.235-14.064-26.863-54.06-29.547-66.781c1.58-0.395,3.106-0.775,4.557-1.131
   l5.307-1.243c5.479-1.293,10.628-2.404,13.775-2.977c1.003-0.181,2.006-0.36,3.009-0.542
   C164.579,75.597,163.787,86.677,159.725,119.808"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M194.834,40.057c-0.197,0.023-0.391,0.05-0.588,0.077c-0.515,0.074-1.03,0.159-1.545,0.24l-0.495,0.081
   c-0.918,0.148-1.831,0.295-2.749,0.446c-1.139,0.186-2.276,0.371-3.415,0.561c-1.319,0.217-2.64,0.438-3.964,0.658
   c-1.46,0.244-2.923,0.492-4.383,0.74c-1.559,0.263-3.124,0.53-4.683,0.797c-0.098,0.016-0.396,0.074-0.694,0.136
   c-0.29,0.062-0.585,0.12-0.677,0.135l-0.767,0.132c-0.15-0.809-2.629-13.864-3.709-16.57c-0.708-1.781-1.908-2.698-2.732-3.147
   c7.618-1.638,15.419-3.205,23.449-4.712c0.851-0.162,1.37-0.104,1.687,0.182c0.337,0.306,0.503,0.898,0.655,1.696
   c0.294,1.564,0.573,2.989,0.851,4.355l0.337,1.657C192.353,32.531,193.44,36.518,194.834,40.057"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M170.162,47.212l-8.439,1.649c-0.187,0.035-0.311-0.039-0.318-0.077c0.213-1.061-0.082-2.652-0.094-2.722
   c-0.108-0.546-2.605-13.411-3.658-16.058c-0.755-1.897-2.113-3.005-2.911-3.52c2.854-0.646,5.733-1.285,8.633-1.912l-0.004,0.015
   c0.09,0.023,2.187,0.604,3.202,3.144c1.065,2.675,3.651,16.337,3.678,16.473C170.413,45.11,170.522,46.674,170.162,47.212"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M160.611,45.81l-2.241,0.395c-1.557,0.278-3.113,0.557-4.669,0.84c-3.155,0.577-8.317,1.692-13.806,2.985
   l-5.311,1.242c-4.417,1.088-9.447,2.362-14.948,3.787c-0.67-3.276-2.528-12.544-2.679-14.812c-0.155-2.312,0.654-3.988,0.883-4.41
   c11.687-3.283,23.63-6.318,36.023-9.152l-0.012,0.027c0.024,0.012,2.219,1.038,3.206,3.527
   C157.99,32.585,160.185,43.638,160.611,45.81"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M120.093,59c-0.012,0.02-0.038,0.066-0.101,0.078l-5.958,1.234c-0.371-0.402-0.789-1.765-0.987-2.682
   c-0.026-0.132-2.729-13.213-2.915-15.97c-0.15-2.296,0.701-3.627,0.926-3.937c1.971-0.542,3.968-1.096,5.962-1.653
   c-0.349,0.809-0.829,2.3-0.701,4.22c0.185,2.799,2.814,15.516,2.926,16.058c0.016,0.066,0.353,1.634,0.844,2.544
   C120.113,58.935,120.105,58.973,120.093,59"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M109.494,41.703c-0.117-1.773,0.309-3.016,0.673-3.736c-0.499,0.135-0.999,0.275-1.494,0.41
   c-7.146,1.959-14.533,3.984-21.827,6.318c-0.093,0.035-0.167,0.144-0.167,0.263v18.92c2.199-0.608,13.063-3.592,25.583-6.891
   C111.669,54.095,109.657,44.141,109.494,41.703 M90.404,56.871c-1.154,0-2.021-1.886-2.021-4.382c0-2.501,0.867-4.387,2.021-4.387
   c1.157,0,2.024,1.886,2.024,4.387C92.428,54.985,91.561,56.871,90.404,56.871 M99.436,54.161c-1.154,0-2.021-1.886-2.021-4.383
   c0-2.5,0.867-4.386,2.021-4.386c1.157,0,2.024,1.886,2.024,4.386C101.46,52.275,100.593,54.161,99.436,54.161"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M463.804,416.582c-0.345,33.36-1.107,64.834-3.427,71.547c-2.391,0.693-32.283,8.904-71.829,0
   c-0.236-3.116-2.118-39.716-3.709-71.036c11.583,1.773,23.647,2.388,34.808,2.388C440.556,419.481,458.303,417.325,463.804,416.582"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M344.243,416.802c-1.595,31.381-3.484,68.198-3.725,71.327c-39.546,8.903-69.436,0.693-71.829,0
   c-2.311-6.702-3.078-38.072-3.423-71.362c12.04,1.997,24.778,2.679,36.55,2.679C320.825,419.446,337.306,417.673,344.243,416.802"
      />
      <path
        fill="#E5E5E5"
        d="M465.333,327.547c-0.043,0.372-0.089,0.682-0.14,0.933c-0.549,2.737-0.797,13.686-0.952,28.505
   c-5.711,0.778-46.987,6.017-82.279,0.066c-0.294-7.828-0.666-18.161-1.022-29.519c12.837,2.373,26.489,3.17,39.008,3.17
   C442.848,330.702,461.953,328.047,465.333,327.547"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M464.237,357.632c-0.077,7.677-0.132,16.36-0.186,25.462c-0.003,0.925-0.011,1.858-0.015,2.795
   c-8.471,1.15-47.2,5.823-80.766,0.341c-0.429-8.572-0.712-14.135-0.723-14.383c-0.008-0.213-0.237-5.609-0.562-14.142
   c12.462,2.091,25.656,2.792,37.773,2.792C441.829,360.497,460.323,358.166,464.237,357.632"
      />
      <path
        fill="#E5E5E5"
        d="M464.032,386.536c-0.059,9.558-0.124,19.554-0.225,29.399c-8.238,1.119-45.647,5.633-79.004,0.507
   c-0.565-11.145-1.095-21.587-1.498-29.562c11.897,1.936,24.433,2.602,36.043,2.602C440.428,389.482,458.449,387.291,464.032,386.536
   "
      />
      <path
        fill="#E5E5E5"
        d="M345.769,386.779c-0.402,7.917-0.929,18.289-1.49,29.373c-11.096,1.397-47.488,5.218-79.02-0.036
   c-0.1-9.891-0.166-19.941-0.224-29.55c12.465,2.176,25.717,2.915,37.935,2.915C322.158,389.481,338.781,387.67,345.769,386.779"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M347.093,357.322c-0.329,8.757-0.562,14.305-0.573,14.522c-0.012,0.248-0.29,5.772-0.72,14.285
   c-11.289,1.444-48.698,5.42-80.77-0.213c-0.003-0.948-0.011-1.893-0.015-2.83c-0.054-9.013-0.105-17.615-0.182-25.234
   c11.684,1.971,24.115,2.66,35.78,2.66C321.406,360.512,339.756,358.325,347.093,357.322"
      />
      <path
        fill="#E5E5E5"
        d="M348.126,327.625c-0.353,11.138-0.716,21.289-1.006,29.047c-11.308,1.557-49.736,6.043-82.271,0.534
   l-0.02,0.12c-0.154-14.99-0.402-26.089-0.952-28.846c-0.055-0.267-0.105-0.6-0.151-0.995c12.903,2.374,26.662,3.171,39.314,3.171
   C324.333,330.656,342.481,328.403,348.126,327.625"
      />
      <path
        fill="#E5E5E5"
        d="M463.006,151.352l-44.939,0.189c0.003-0.058,0.011-0.112,0.015-0.174c0.031-0.387,0.082-1.014,0.179-1.203
   h44.718C462.986,150.558,462.994,150.953,463.006,151.352"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M463.885,190.546l-39.589,0.155c-0.43-0.573-2.056-2.064-3.627-3.511c-1.115-1.022-2.262-2.08-2.516-2.389
   l-0.113-32.617l44.978-0.193c0.228,10.638,0.496,22.346,0.774,34.513C463.823,187.844,463.854,189.191,463.885,190.546"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M313.973,152.184l-0.112,32.617c-0.255,0.309-1.406,1.366-2.517,2.388c-1.575,1.448-3.197,2.939-3.627,3.512
   l-42.535-0.132c0.031-1.366,0.062-2.725,0.093-4.076c0.278-12.161,0.546-23.848,0.774-34.475L313.973,152.184z"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M461.69,113.819c-0.108-0.259-0.213-0.519-0.317-0.778c-0.113-0.275-0.225-0.55-0.333-0.829
   c-0.19-0.472-0.379-0.944-0.565-1.417c-0.143-0.368-0.291-0.731-0.431-1.099c-0.119-0.302-0.235-0.604-0.351-0.91
   c-7.356-19.086-13.317-40.84-18.165-66.232l1.177-0.023c4.444-0.062,8.08-0.089,8.888-0.097c0.071,2.861,0.434,5.668,1.092,8.378
   C455.941,64.195,459.794,85.07,461.69,113.819"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M451.624,39.434c-0.034,0.79-0.046,1.576-0.038,2.362c-0.81,0.004-4.448,0.034-8.89,0.096l-6.209,0.113
   c-3.852,0.054-8.261,0.12-13.023,0.189V22.09l16.751,0.12c0.291,0,6.81,0.023,9.605-3.735
   C450.39,21.01,452.069,30.116,451.624,39.434"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M422.818,22.086v21.932c0,0.375-0.303,0.681-0.678,0.681h-13.522c-0.376,0-0.682-0.306-0.682-0.681V21.982
   L422.818,22.086z"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M364.533,21.676l-0.603,0.012l-10.771,0.108l-3.31,5.73c-0.797,1.378-1.467,2.656-1.611,4.32
   c-0.15,1.785,0.217,3.62,1.038,5.165c0.554,1.037,1.118,2.071,1.684,3.109c0.573,1.045,1.143,2.09,1.699,3.143
   c4.363-0.008,8.328-0.047,11.87-0.112c10.743-0.202,25.133-0.441,42.76-0.712V21.978L364.533,21.676z M358.691,34.835
   c-1.785,0-3.236-1.452-3.236-3.236c0-1.782,1.451-3.233,3.236-3.233c1.785,0,3.237,1.451,3.237,3.233
   C361.928,33.383,360.476,34.835,358.691,34.835 M373.29,34.835c-1.784,0-3.236-1.452-3.236-3.236c0-1.782,1.452-3.233,3.236-3.233
   c1.785,0,3.236,1.451,3.236,3.233C376.526,33.383,375.075,34.835,373.29,34.835"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M350.399,40.429c0.516,0.94,1.03,1.885,1.537,2.834c-8.741,0.007-19.066-0.101-30.858-0.329v-20.82
   l31.339-0.314l-3.121,5.404c-0.836,1.448-1.541,2.791-1.692,4.588c-0.166,1.905,0.229,3.864,1.108,5.516
   C349.265,38.35,349.835,39.387,350.399,40.429"
      />
      <path
        fill={darkenColor}
        d="M449.441,17.893c-2.517,3.693-9.14,3.682-9.222,3.678l-75.693-0.538l-0.607,0.015l-75.431,0.747
   c-0.066,0-6.372-0.185-8.869-3.91c3.201-0.658,22.841-4.533,51.439-6.542C359.733,9.33,403.511,8.838,449.441,17.893"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M320.431,22.117v21.901c0,0.375-0.307,0.681-0.682,0.681h-13.518c-0.376,0-0.682-0.306-0.682-0.681v-21.75
   L320.431,22.117z"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M304.902,22.272v20.301c-4.643-0.116-8.939-0.232-12.687-0.34l-5.985-0.229
   c-4.308-0.135-8.134-0.201-8.947-0.212c0.078-1.545,0.108-3.102,0.09-4.666c-0.106-8.494,1.354-16.325,1.873-18.648
   c2.764,3.771,8.951,3.953,9.237,3.957L304.902,22.272z"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M287.419,42.69c-4.843,25.334-10.798,47.045-18.138,66.104c-0.116,0.298-0.232,0.6-0.348,0.902
   c-0.143,0.368-0.29,0.736-0.434,1.099c-0.185,0.473-0.371,0.945-0.561,1.414c-0.112,0.278-0.224,0.557-0.336,0.836
   c-0.067,0.163-0.132,0.329-0.203,0.492c1.79-26.79,5.266-46.581,8.208-59.442c0.864-3.775,1.406-7.681,1.638-11.664
   c0.751,0.011,4.611,0.077,8.962,0.213L287.419,42.69z"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M197.599,41.594c-0.279,0.159-0.926,0.244-1.34,0.279l-0.185-0.395c0.581-0.182,0.94-0.422,1.107-0.739
   c0.132-0.248,0.135-0.527,0.02-0.829c-1.139-2.88-2.525-8.695-3.64-13.368c-0.619-2.594-1.157-4.835-1.525-6.066
   c-0.229-0.771-1.065-0.713-1.654-0.628c-0.1-0.197-0.227-0.367-0.383-0.506c-0.073-0.07-0.155-0.128-0.244-0.183l1.959-0.294
   c0.434-0.054,1.057,0.592,1.169,1.092c0.782,3.484,3.473,15.195,5.25,19.701C198.397,40.317,198.33,41.172,197.599,41.594"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        x1="159.005"
        y1="120.614"
        x2="155.801"
        y2="120.614"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M215.583,344.833
   c-0.198,0.052-0.398,0.104-0.603,0.157"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="0.011,0"
        x1="213.713"
        y1="345.312"
        x2="213.706"
        y2="345.314"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.32,1.308,0.011,0"
        d="
   M213.706,345.314c-5.938,1.487-13.814,3.163-20.633,4.421"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M193.065,349.736
   c-0.205,0.038-0.41,0.076-0.613,0.113"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M215.195,342.897
   c-0.197,0.052-0.398,0.104-0.603,0.157"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="0.011,0"
        x1="213.326"
        y1="343.376"
        x2="213.318"
        y2="343.377"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.32,1.308,0.011,0"
        d="
   M213.318,343.378c-5.937,1.487-13.814,3.163-20.633,4.421"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M192.677,347.801
   c-0.205,0.038-0.409,0.075-0.612,0.112"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M156.027,479.015c0,0,0.214,0.043,0.62,0.117"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        x1="157.91"
        y1="479.352"
        x2="157.911"
        y2="479.352"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.284,1.283"
        d="
   M157.911,479.352c6.879,1.15,31.261,4.529,50.931-1.445"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M208.843,477.906
   c0.202-0.061,0.403-0.124,0.604-0.187"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        x1="216.04"
        y1="475.849"
        x2="216.041"
        y2="475.849"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.215,1.214"
        d="
   M210.139,477.516c3.812-1.163,18.634-5.617,21.974-7.232"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M232.112,470.284
   c0.21-0.102,0.398-0.199,0.562-0.29"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.264,1.264"
        d="M21.482,447.208
   c0,0,19.677,7.211,41.486,4.306"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.264,1.264"
        d="M63.757,451.319
   c0,0,24.551-1.644,33.172-4.717"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.32"
        strokeMiterlimit="10"
        x1="96.617"
        y1="62.39"
        x2="96.63"
        y2="62.87"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.32"
        strokeMiterlimit="10"
        x1="96.656"
        y1="63.821"
        x2="96.656"
        y2="63.822"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.32"
        strokeMiterlimit="10"
        strokeDasharray="0.953,0.951"
        d="M96.656,63.822
   l1.556,56.36c0,0-0.321,12.386-8.282,14.667"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.32"
        strokeMiterlimit="10"
        d="M89.931,134.849
   c-0.152,0.043-0.308,0.083-0.465,0.12"
      />
      <polyline
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        points="
   166.068,25.308 170.225,24.487 188.742,20.987 "
      />
      <polyline
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        points="
   117.627,37.196 130.937,33.406 138.727,31.488 154.845,27.775 "
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        x1="87.717"
        y1="45.712"
        x2="109.245"
        y2="39.582"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        d="M170.905,42.447
   l2.029-0.348c0,0,8.468-1.355,19.871-3.274"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        d="M119.568,53.637
   l13.174-3.522l8.039-1.877c0,0,9.813-2.468,19.269-4.043"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        x1="87.717"
        y1="62.154"
        x2="111.881"
        y2="55.693"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        d="M212.436,145.064
   l-21.104,2.127c-1.698-1.679-4.986-4.943-6.485-6.437l-3.992-39.251c0.156,0.118,0.306,0.23,0.446,0.336
   c0.386,0.289,0.706,0.53,0.933,0.699c0.117,0.088,0.216,0.161,0.286,0.213c0.71,0.521,1.48,0.746,2.289,0.667
   c0.046-0.005,0.092-0.011,0.137-0.017l30.042-3.007"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        d="M212.194,147.023
   l-21.571,2.175c-1.472-1.452-6.358-6.301-7.622-7.566l-4.508-44.325c0.648,0.49,1.149,0.869,1.163,0.88
   c1.019,0.77,2.037,1.538,2.802,2.113c0.382,0.288,0.702,0.528,0.927,0.696c0.113,0.085,0.205,0.152,0.269,0.199
   c0.136,0.101,0.483,0.354,0.967,0.307c0.027-0.003,0.054-0.007,0.083-0.012l30.183-3.021"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        d="M214.279,94.064
   l-28.589,2.862c-1.301-0.978-6.095-4.85-6.095-4.85l-1.819-17.993l30.551-3.067"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        d="M214.411,95.985
   l-29.562,2.959c-1.126-0.84-4.509-3.399-6.71-5.066l-0.637-0.533l-2.122-20.957l33.007-3.313"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        x1="183.349"
        y1="117.034"
        x2="216.002"
        y2="113.833"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M126.291,54.219
   c0.043,0.204,0.086,0.408,0.129,0.612"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        x1="126.678"
        y1="56.036"
        x2="126.68"
        y2="56.046"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.243,1.232"
        d="M126.68,56.046
   c5.522,25.531,15.819,54.958,29.809,65.923c0,0,1.352,1.344,3.12,1.717"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M159.609,123.686
   c0.203,0.043,0.411,0.073,0.623,0.086"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M97.353,399.215
   c-0.201,0.029-0.407,0.058-0.618,0.086"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        x1="95.55"
        y1="399.454"
        x2="95.54"
        y2="399.455"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.205,1.195"
        d="M95.54,399.455
   c-9.774,1.199-26.704,1.979-28.692,2.074l-0.096,0.004c-0.025,0.002-1.319,0.033-2.457,0.082"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M64.293,401.614
   c-0.219,0.009-0.431,0.02-0.628,0.03"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M63.982,375.792
   c0.182-0.011,0.389-0.022,0.62-0.036"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        x1="65.821"
        y1="375.686"
        x2="65.829"
        y2="375.686"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.233,1.222"
        d="M65.829,375.685
   c6.543-0.377,23.133-1.354,31.951-2.465"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M97.784,373.219
   c0.211-0.027,0.417-0.053,0.619-0.08"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M61.478,401.842
   c-0.199,0.007-0.406,0.015-0.621,0.022"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        x1="59.642"
        y1="401.902"
        x2="59.634"
        y2="401.902"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.227,1.216"
        d="M59.634,401.902
   c-3.543,0.104-8.559,0.192-13.356,0.192c-7.538,0-16.344-0.214-23.418-0.638"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M22.853,401.456
   c-0.21-0.012-0.418-0.025-0.624-0.038"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M97.353,397.279
   c-0.201,0.029-0.407,0.058-0.618,0.086"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        x1="95.55"
        y1="397.518"
        x2="95.54"
        y2="397.519"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.205,1.195"
        d="M95.54,397.519
   c-9.774,1.199-26.704,1.979-28.692,2.074l-0.096,0.004c-0.025,0.002-1.319,0.033-2.457,0.082"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M64.293,399.679
   c-0.219,0.009-0.431,0.019-0.628,0.03"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M61.478,399.906
   c-0.199,0.007-0.406,0.015-0.621,0.022"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        x1="59.642"
        y1="399.966"
        x2="59.634"
        y2="399.966"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.227,1.216"
        d="M59.634,399.967
   c-3.543,0.104-8.559,0.192-13.356,0.192c-7.538,0-16.344-0.214-23.418-0.638"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M22.853,399.52
   c-0.21-0.013-0.418-0.025-0.624-0.038"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M20.753,375.769
   c0.206,0.012,0.413,0.024,0.622,0.037"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="0.01,0"
        x1="22.633"
        y1="375.876"
        x2="22.64"
        y2="375.876"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.272,1.261,0.01,0"
        d="
   M22.64,375.876c6.587,0.354,13.996,0.533,20.924,0.533c7.097,0,13.585-0.191,17.211-0.347"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M60.78,376.062
   c0.217-0.009,0.424-0.019,0.62-0.028"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M63.982,377.727
   c0.182-0.011,0.389-0.022,0.62-0.036"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        x1="65.821"
        y1="377.621"
        x2="65.829"
        y2="377.621"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.233,1.222"
        d="M65.829,377.621
   c6.543-0.377,23.133-1.354,31.951-2.465"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M97.784,375.155
   c0.211-0.027,0.417-0.053,0.619-0.08"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M20.753,377.704
   c0.206,0.012,0.413,0.025,0.622,0.037"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="0.01,0"
        x1="22.633"
        y1="377.811"
        x2="22.64"
        y2="377.811"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.272,1.261,0.01,0"
        d="
   M22.64,377.812c6.587,0.354,13.996,0.533,20.924,0.533c7.097,0,13.585-0.191,17.211-0.347"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M60.78,377.998
   c0.217-0.009,0.424-0.019,0.62-0.027"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M99.19,341.099
   c-0.201,0.027-0.407,0.055-0.619,0.083"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="0.01,0"
        x1="97.296"
        y1="341.337"
        x2="97.285"
        y2="341.338"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.297,1.285,0.01,0"
        d="
   M97.285,341.338c-9.48,1.098-26.489,1.872-31.033,2.077"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M66.248,343.415
   c-0.243,0.011-0.451,0.021-0.62,0.028"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M68.716,317.438
   c0.201-0.012,0.408-0.024,0.622-0.036"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        x1="70.526"
        y1="317.332"
        x2="70.534"
        y2="317.332"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.202,1.191"
        d="M70.534,317.332
   c7.708-0.449,21.232-1.246,28.746-2.138"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M99.285,315.194
   c0.212-0.025,0.418-0.05,0.62-0.076c-0.004,0.031-0.008,0.061-0.011,0.092"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M62.237,343.639
   c-0.201,0.007-0.408,0.015-0.623,0.022"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="0.01,0"
        x1="60.367"
        y1="343.703"
        x2="60.359"
        y2="343.703"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.259,1.248,0.01,0"
        d="
   M60.359,343.703c-3.739,0.119-9.057,0.24-15.239,0.24c-8.474,0-17.587-0.223-25.025-0.664"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M20.092,343.28
   c-0.209-0.013-0.417-0.025-0.623-0.038"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M99.576,339.163
   c-0.201,0.027-0.407,0.055-0.618,0.082"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="0.01,0"
        x1="97.683"
        y1="339.402"
        x2="97.672"
        y2="339.403"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.297,1.285,0.01,0"
        d="
   M97.672,339.403c-9.479,1.098-26.488,1.871-31.032,2.077"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M66.636,341.479
   c-0.244,0.011-0.452,0.021-0.62,0.028"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M62.624,341.703
   c-0.2,0.007-0.408,0.015-0.622,0.022"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="0.01,0"
        x1="60.743"
        y1="341.768"
        x2="60.734"
        y2="341.768"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.271,1.26,0.01,0"
        d="
   M60.734,341.768c-3.738,0.119-9.051,0.24-15.227,0.24c-8.474,0-17.955-0.223-25.412-0.664"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M20.092,341.343
   c-0.21-0.012-0.417-0.025-0.623-0.038"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M19.156,317.566
   c0.207,0.013,0.415,0.025,0.624,0.038"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        x1="21.003"
        y1="317.673"
        x2="21.013"
        y2="317.674"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.236,1.225"
        d="M21.013,317.674
   c7.08,0.387,15.369,0.583,22.927,0.583c11.797,0,19.889-0.483,19.969-0.488c0,0,0.865-0.023,1.555-0.048"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M65.465,317.721
   c0.248-0.009,0.475-0.019,0.629-0.027"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M68.716,319.373
   c0.201-0.012,0.408-0.024,0.622-0.036"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        x1="70.526"
        y1="319.268"
        x2="70.534"
        y2="319.268"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.202,1.191"
        d="M70.534,319.267
   c7.708-0.449,21.232-1.246,28.746-2.138"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M99.285,317.129
   c0.212-0.025,0.418-0.05,0.62-0.076c-0.004,0.031-0.008,0.061-0.011,0.092"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M19.156,319.502
   c0.207,0.013,0.415,0.025,0.624,0.038"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        x1="21.003"
        y1="319.609"
        x2="21.013"
        y2="319.609"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.236,1.225"
        d="M21.013,319.61
   c7.08,0.387,15.369,0.583,22.927,0.583c11.797,0,19.889-0.483,19.969-0.488c0,0,0.865-0.023,1.555-0.048"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M65.465,319.656
   c0.248-0.009,0.475-0.018,0.629-0.026"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M197.332,382.32
   c0.204-0.036,0.409-0.072,0.615-0.108"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        x1="199.117"
        y1="381.998"
        x2="199.126"
        y2="381.996"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.2,1.189"
        d="M199.126,381.996
   c7.001-1.31,15.03-3.312,21.025-4.877"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M220.152,377.118
   c0.204-0.053,0.405-0.105,0.604-0.158"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M223.359,403.5
   c-0.199,0.052-0.4,0.105-0.604,0.158"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="0.01,0"
        x1="221.545"
        y1="403.967"
        x2="221.536"
        y2="403.969"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.26,1.249,0.01,0"
        d="
   M221.536,403.968c-5.91,1.486-13.245,3.026-19.715,4.181"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M201.819,408.15
   c-0.206,0.037-0.412,0.073-0.616,0.109"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M198.493,408.646
   c-0.202,0.033-0.407,0.066-0.614,0.098"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        x1="196.653"
        y1="408.932"
        x2="196.646"
        y2="408.933"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.24"
        d="M196.647,408.933
   c-3.638,0.547-7.752,1.063-11.431,1.528c-14.259,1.815-27.256,2.98-38.299,3.64"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M146.91,414.102
   c-0.209,0.013-0.416,0.025-0.623,0.037"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M222.973,401.564
   c-0.2,0.053-0.401,0.105-0.604,0.158"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="0.01,0"
        x1="221.158"
        y1="402.031"
        x2="221.149"
        y2="402.033"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.26,1.249,0.01,0"
        d="
   M221.15,402.033c-5.911,1.486-13.245,3.026-19.715,4.181"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M201.432,406.214
   c-0.206,0.037-0.411,0.073-0.615,0.109"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M198.107,406.71
   c-0.203,0.033-0.408,0.065-0.614,0.098"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        x1="196.267"
        y1="406.997"
        x2="196.26"
        y2="406.998"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.24"
        d="M196.26,406.998
   c-3.638,0.547-7.753,1.062-11.432,1.528c-14.258,1.815-27.255,2.98-38.298,3.64"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M146.523,412.167
   c-0.208,0.012-0.416,0.024-0.622,0.037"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M140.519,388.499
   c0.205-0.012,0.412-0.024,0.619-0.037"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        x1="142.371"
        y1="388.386"
        x2="142.38"
        y2="388.385"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.246,1.235"
        d="M142.38,388.385
   c12.253-0.767,27.337-2.095,39.532-3.646c4.001-0.508,8.745-1.329,12.475-1.932"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M194.393,382.807
   c0.209-0.034,0.414-0.067,0.616-0.099"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M197.719,384.256
   c0.204-0.035,0.409-0.071,0.616-0.108"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        x1="199.504"
        y1="383.934"
        x2="199.514"
        y2="383.932"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.2,1.189"
        d="M199.514,383.932
   c7-1.31,15.029-3.312,21.024-4.877"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M220.54,379.054
   c0.203-0.053,0.404-0.106,0.604-0.158"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M140.905,390.435
   c0.206-0.012,0.412-0.024,0.62-0.037"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        x1="142.758"
        y1="390.322"
        x2="142.768"
        y2="390.322"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.246,1.235"
        d="
   M142.768,390.321c12.252-0.767,27.337-2.096,39.532-3.646c4.001-0.509,8.745-1.329,12.475-1.932"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M194.779,384.742
   c0.209-0.034,0.415-0.067,0.617-0.099"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M129.575,330.564l-0.017-0.129
   c0.207-0.012,0.414-0.025,0.622-0.037"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="0.01,0"
        x1="131.435"
        y1="330.321"
        x2="131.442"
        y2="330.321"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.267,1.256,0.01,0"
        d="
   M131.441,330.321c12.572-0.784,27.8-2.144,39.632-3.652c4.491-0.57,9.308-1.152,13.283-1.767"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M184.362,324.901
   c0.208-0.032,0.414-0.064,0.617-0.097"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M189.56,350.245
   c-0.204,0.035-0.41,0.069-0.617,0.103"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        x1="187.737"
        y1="350.544"
        x2="187.727"
        y2="350.546"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.232,1.221"
        d="
   M187.728,350.546c-4.442,0.707-9.267,1.326-13.353,1.845c-13.09,1.667-28.642,3.005-40.529,3.716"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M133.845,356.107
   c-0.209,0.012-0.417,0.024-0.623,0.037"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M189.172,348.309
   c-0.204,0.035-0.409,0.069-0.616,0.104"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        x1="187.351"
        y1="348.609"
        x2="187.341"
        y2="348.61"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.232,1.221"
        d="M187.341,348.61
   c-4.442,0.708-9.267,1.326-13.354,1.845c-13.089,1.667-28.642,3.005-40.529,3.716"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M133.457,354.171
   c-0.209,0.013-0.416,0.025-0.623,0.037"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M187.499,324.45
   c0.204-0.036,0.409-0.072,0.615-0.108"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="0.01,0"
        x1="189.337"
        y1="324.118"
        x2="189.347"
        y2="324.116"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.244,0.01,0"
        d="
   M189.347,324.116c6.469-1.214,13.991-3.057,19.554-4.501"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M208.902,319.614
   c0.204-0.053,0.405-0.105,0.604-0.157"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M129.963,332.5l-0.017-0.129
   c0.206-0.012,0.413-0.024,0.622-0.037"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="0.01,0"
        x1="131.821"
        y1="332.257"
        x2="131.828"
        y2="332.257"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.267,1.256,0.01,0"
        d="
   M131.828,332.257c12.572-0.784,27.8-2.144,39.632-3.652c4.491-0.57,9.308-1.152,13.283-1.767"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M184.75,326.836
   c0.208-0.032,0.413-0.064,0.617-0.097"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M187.887,326.386
   c0.203-0.035,0.408-0.071,0.614-0.108"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="0.01,0"
        x1="189.725"
        y1="326.053"
        x2="189.735"
        y2="326.051"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.244,0.01,0"
        d="
   M189.734,326.051c6.468-1.214,13.99-3.057,19.554-4.501"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M209.289,321.549
   c0.204-0.053,0.405-0.105,0.604-0.157"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        d="M127.841,199.19
   c1.416,13.073,3.081,26.961,4.568,39.484c0.589,4.953,1.068,8.984,1.383,11.711l34.653-4.153l33.312-3.807l-9.214-80.633"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        x1="175.507"
        y1="181.099"
        x2="193.422"
        y2="179.052"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        x1="175.009"
        y1="176.74"
        x2="192.924"
        y2="174.693"
      />
      <polyline
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.289"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        points="
   191.606,161.369 193.262,161.981 191.687,161.969 193.387,162.977 191.813,162.965 193.491,163.774 191.917,163.763 
   193.593,164.571 192.019,164.56 193.697,165.368 192.123,165.357 193.799,166.164 192.226,166.154 193.902,166.96 "
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        d="M169.73,154.698
   l3.679,31.466c-0.391,0.516-3.768,4.75-4.34,5.532l-38.078,4.498c-0.61-0.609-4.26-4.011-4.855-4.6l-3.659-31.292"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        x1="123.563"
        y1="164.355"
        x2="169.835"
        y2="159.067"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        x1="175.582"
        y1="188.49"
        x2="181.846"
        y2="243.308"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M119.307,58.958
   c-0.093-0.17-0.18-0.366-0.26-0.572"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        x1="118.675"
        y1="57.234"
        x2="118.673"
        y2="57.225"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.22,1.209"
        d="M118.673,57.225
   c-0.113-0.417-0.179-0.722-0.179-0.722s-2.733-13.205-2.92-16.016c-0.068-1.017,0.048-1.833,0.225-2.46"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M115.798,38.031
   c0.062-0.22,0.13-0.417,0.201-0.59"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M114.554,59.943
   c-0.093-0.17-0.18-0.367-0.26-0.573"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        x1="113.923"
        y1="58.218"
        x2="113.92"
        y2="58.209"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.22,1.209"
        d="M113.92,58.209
   c-0.113-0.417-0.179-0.722-0.179-0.722s-2.733-13.205-2.92-16.016c-0.068-1.018,0.049-1.833,0.225-2.46"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M111.045,39.015
   c0.062-0.22,0.13-0.417,0.201-0.591"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M162.54,48.436
   c0.038-0.192,0.06-0.405,0.067-0.625"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        x1="162.555"
        y1="46.581"
        x2="162.554"
        y2="46.571"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.242,1.231"
        d="M162.554,46.571
   c-0.047-0.437-0.104-0.75-0.104-0.75s-2.591-13.418-3.65-16.081c-0.392-0.986-0.93-1.673-1.451-2.145"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M157.352,27.597
   c-0.166-0.151-0.33-0.28-0.487-0.39"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M169.189,47.123
   c0.041-0.192,0.064-0.405,0.075-0.624"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="0.01,0"
        x1="169.22"
        y1="45.238"
        x2="169.219"
        y2="45.228"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.273,1.261,0.01,0"
        d="
   M169.219,45.228c-0.046-0.455-0.104-0.782-0.104-0.782s-2.604-13.733-3.688-16.455c-0.406-1.019-0.971-1.723-1.516-2.205"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M163.914,25.789
   c-0.166-0.147-0.331-0.274-0.489-0.382"
      />
      <path
        fill="#010101"
        d="M234.349,483.932c-0.445-9.055-7.382-63.94-7.452-64.486c-0.043-0.433-4.549-43.685-7.453-61.996
   c-1.849-11.681-5.45-26.245-8.144-36.403c-1.472-5.544-2.176-11.266-2.099-17.007c0.147-10.325,0.256-23.442-0.027-27.29
   c-0.329-4.417-1.332-19.779-0.488-32.036c0.135-1.997,0.322-4.436,0.535-7.255c0.987-13.031,2.643-34.842,2.55-54.168
   c-0.092-18.703,0.891-31.316,1.321-35.869c0.077-0.855,0.232-1.703,0.457-2.528c2.144-7.839,11.502-49.376-14.681-97.443
   l-2.412-5.157c0.422-0.038,1.03-0.131,1.359-0.321c0.832-0.48,1.123-1.475,0.728-2.478c-1.766-4.475-4.452-16.159-5.231-19.635
   c-0.142-0.627-0.913-1.522-1.66-1.429l-3.218,0.484c-0.205,0.012-0.429,0.039-0.672,0.085c-25.239,4.742-48.254,10.07-70.364,16.295
   c-2.98,0.84-5.989,1.665-8.896,2.462c-7.151,1.963-14.545,3.988-21.865,6.334c-0.361,0.135-0.601,0.484-0.601,0.867v19.76
   l0.012-0.004c0.081,3.035,0.6,22.303,1.08,37.788l0.008,0.237c-0.279,0.472-0.558,0.948-0.832,1.424
   c-0.832,1.433-1.654,2.869-2.474,4.305c-1.235,2.172-2.524,4.46-3.825,6.798c-1.646,2.955-3.307,5.974-4.937,8.978
   c-1.951,3.589-3.902,7.24-5.806,10.848c-2.18,4.13-4.344,8.308-6.435,12.408c-2.334,4.579-4.63,9.175-6.821,13.658
   c-2.405,4.92-4.746,9.834-6.961,14.603c-2.401,5.165-4.711,10.286-6.867,15.23c-2.316,5.308-4.511,10.542-6.528,15.551
   c-2.148,5.347-4.15,10.581-5.942,15.563c-1.937,5.362-3.612,10.356-5.126,15.269c-1.599,5.192-2.927,9.989-4.058,14.661l-0.15,0.624
   c-1.123,4.63-2.28,9.418-2.718,14.169c-0.224,2.435-0.194,4.901-0.159,7.282c0.012,0.786,0.019,1.575,0.023,2.362l0.012,4.92
   c0.012,4.011,0.027,8.021,0.046,12.032c0.023,4.719,0.051,9.443,0.086,14.162c0.034,5.106,0.077,10.209,0.131,15.315
   c0.054,5.513,0.116,10.585,0.186,15.501c0.077,5.385,0.159,10.201,0.251,14.723c0.105,4.979,0.209,9.102,0.329,12.97
   c0.097,3.027,0.221,6.608,0.419,10.254l0.011,0.221c0.112,2.087,0.229,4.247,0.504,6.361c0.042,0.31,0.093,0.682,0.162,1.045
   c1.947,10.062,1.955,30.917,1.015,39.535c-0.899,8.176,1.219,33.898,1.238,34.157l0.016,0.178l0.159,0.082
   c0.104,0.05,10.116,5.017,25.946,5.017c0.503,0,1.014-0.008,1.529-0.016c15.78-0.317,26.326-0.758,36.84-2.16
   c9.989-1.335,10.72-3.705,10.771-3.972l0.008-0.058c0-0.368,0.123-36.751,1.238-52.364c0.65-9.071,1.212-18.835,1.726-29.853
   c0.372-7.947,0.744-16.418,0.864-24.939c0.05-3.609,0.004-7.24-0.042-10.751c-0.101-7.619-0.205-15.497,0.716-23.325
   c1.765-15.056,4.846-30.151,7.824-44.75c0.36-1.761,0.719-3.523,1.076-5.284c0.879-4.344,2.276-8.962,5.896-10.654
   c0.647,3.29,5.029,25.671,5.803,32.268c0.775,6.581,5.517,43.863,6.531,51.753c1.007,7.828,12.776,61.315,12.896,61.861
   c0.097,0.398,9.605,39.91,11.057,56.626c1.467,16.942,4.966,32.381,5.606,33.147c0.456,0.55,8.881,3.09,21.853,3.516
   c1.173,0.039,2.417,0.062,3.721,0.062c12.125,0,29.74-1.89,50.2-9.807l0.217-0.085L234.349,483.932z M224.694,404.936
   c-7.375,2.005-15.338,3.728-24.076,5.211c-1.39-9.682-2.853-19.628-4.355-29.465c9.093-1.525,17.351-3.31,24.982-5.393
   C222.491,385.289,223.75,396.365,224.694,404.936 M218.813,357.546c0.737,4.65,1.577,10.902,2.42,17.658l-0.147-0.535
   c-7.608,2.079-15.85,3.856-24.92,5.378c-1.448-9.45-2.931-18.796-4.417-27.704c9.058-1.602,17.812-3.507,25.075-5.486
   C217.587,350.535,218.275,354.174,218.813,357.546 M210.68,321.209c1.56,5.892,4.018,15.536,6.012,25.021
   c-7.251,1.974-15.993,3.879-25.048,5.482c-1.769-10.553-3.539-20.48-5.265-29.225c8.672-1.448,16.229-3.082,23.429-5.041
   C210.064,318.708,210.347,319.963,210.68,321.209 M211.129,183.295c0.096,19.299-1.56,41.094-2.547,54.114
   c-0.213,2.822-0.4,5.261-0.534,7.259c-0.845,12.303,0.158,27.704,0.487,32.129c0.298,4.03,0.144,18.791,0.027,27.235
   c-0.058,4.294,0.318,8.579,1.119,12.787c-7.197,1.959-14.749,3.593-23.426,5.041c-1.211-6.125-2.4-11.661-3.546-16.403
   c-3.31-13.701-5.489-29.419-8.816-57.266l29.508-3.182l0.674-0.147l-0.035-0.291c-0.271-2.385-0.941-8.362-1.812-16.175
   c-2.264-20.317-6.058-54.319-7.708-68.035l-0.038-0.322l-21.61,2.47l-1.007-8.602c-0.008-0.066-0.031-0.124-0.058-0.182l0.035-0.004
   l-0.24-2.102l-9.004,1.03l-2.304-32.222c4.038-32.914,4.951-44.796-2.834-73.406c0.341-0.062,0.681-0.123,1.021-0.185l2.242-0.395
   c0.07,0.476,0.194,1.513,0.054,2.218c-0.042,0.217,0.024,0.438,0.187,0.596c0.162,0.163,0.402,0.256,0.662,0.256
   c0.073,0,0.146-0.008,0.221-0.023l8.652-1.692l0.069-0.074c0.585-0.615,0.503-2.156,0.399-3.031l0.778-0.132
   c0.101-0.015,0.399-0.077,0.701-0.139c0.29-0.058,0.58-0.116,0.674-0.136c1.56-0.263,3.12-0.53,4.684-0.793
   c1.46-0.248,2.919-0.496,4.382-0.74c1.321-0.22,2.641-0.441,3.961-0.658c1.138-0.189,2.276-0.375,3.414-0.561l0.871-0.14
   c4.325,9.509,6.999,18.119,7.957,25.602l-24.894,2.443l0.151,1.533L176,94.225l0.093,0.085c0.011,0.012,0.22,0.171,0.538,0.411
   l4.832,47.518l0.011,0.062c0.031,0.1,8.42,8.451,8.548,8.513l0.081,0.034l22.238-2.241
   C211.876,153.98,211.048,166.052,211.129,183.295 M171.242,154.116l3.778,32.28c-0.209,0.34-1.157,1.525-2.075,2.675
   c-1.343,1.68-2.725,3.414-3.077,4.034l-39.427,4.661c-0.429-0.546-1.85-1.858-3.224-3.136c-0.999-0.921-2.034-1.878-2.257-2.156
   l-3.791-32.416L171.242,154.116z M121.096,159.424l-0.159-1.371l50.1-5.726l0.132,1.15L121.096,159.424z M159.724,119.807
   c-17.235-14.064-26.863-54.06-29.546-66.781c1.58-0.395,3.105-0.774,4.556-1.131l5.308-1.242c5.478-1.293,10.628-2.404,13.774-2.977
   c1.003-0.182,2.006-0.36,3.009-0.542C164.579,75.596,163.786,86.676,159.724,119.807 M212.933,144.724
   c-0.236,0.859-0.399,1.746-0.48,2.636c-0.02,0.182-0.035,0.383-0.055,0.592l-22.121,2.23c-0.925-0.901-7.425-7.355-8.183-8.122
   l-4.758-46.805c1.204,0.914,2.856,2.164,2.884,2.184c1.018,0.77,2.036,1.536,2.798,2.114c1.073,0.805,1.364,1.022,1.518,1.022
   c0.023,0,0.047-0.004,0.066-0.016l30.364-3.039C218.388,121.941,214.261,139.862,212.933,144.724 M214.873,96.881l-30.294,3.031
   c-0.728-0.538-5.501-4.149-7.336-5.536l-0.004-0.038l-0.039,0.004c-0.271-0.205-0.477-0.361-0.585-0.442l-2.261-22.349l33.233-3.337
   C211.322,78.399,213.591,88.055,214.873,96.881 M207.358,67.586l-33.069,3.322l-0.085-0.895l32.856-3.22
   C207.161,67.06,207.262,67.323,207.358,67.586 M198.299,47.742c3.419,6.275,6.225,12.435,8.521,18.427l-7.793,0.763
   c-0.96-7.51-3.628-16.136-7.94-25.648c0.406-0.066,0.812-0.132,1.22-0.197l0.499-0.078c0.51-0.085,1.022-0.166,1.533-0.24
   c0.22-0.035,0.441-0.062,0.658-0.089L198.299,47.742z M195.466,39.917c-1.395-3.527-2.483-7.502-3.423-12.52l-0.341-1.66
   c-0.278-1.363-0.558-2.784-0.852-4.348c-0.081-0.422-0.166-0.793-0.282-1.119c0.534-0.069,0.933-0.043,1.045,0.333
   c0.368,1.216,0.902,3.453,1.518,6.043c1.119,4.685,2.512,10.515,3.658,13.426c0.07,0.178,0.074,0.329,0.004,0.461
   c-0.116,0.213-0.418,0.399-0.905,0.542l-0.373-0.793C195.531,40.184,195.523,40.065,195.466,39.917 M191.714,18.865
   c0.433-0.055,1.056,0.592,1.169,1.091c0.782,3.485,3.472,15.196,5.25,19.702c0.263,0.658,0.197,1.514-0.535,1.936
   c-0.279,0.158-0.925,0.244-1.339,0.278l-0.186-0.394c0.581-0.182,0.941-0.423,1.108-0.74c0.131-0.247,0.134-0.526,0.019-0.829
   c-1.139-2.879-2.524-8.694-3.64-13.367c-0.619-2.594-1.157-4.836-1.525-6.067c-0.228-0.77-1.064-0.712-1.653-0.627
   c-0.101-0.197-0.228-0.368-0.383-0.507c-0.073-0.07-0.155-0.128-0.244-0.182L191.714,18.865z M187.882,19.631
   c0.851-0.162,1.37-0.104,1.687,0.182c0.337,0.306,0.503,0.898,0.654,1.696c0.294,1.564,0.574,2.989,0.852,4.355l0.337,1.657
   c0.94,5.01,2.028,8.997,3.422,12.536c-0.197,0.023-0.391,0.05-0.588,0.077c-0.515,0.074-1.03,0.159-1.545,0.24l-0.495,0.081
   c-0.918,0.148-1.831,0.295-2.749,0.446c-1.139,0.186-2.276,0.371-3.415,0.561c-1.319,0.217-2.64,0.438-3.964,0.658
   c-1.46,0.244-2.923,0.492-4.383,0.74c-1.559,0.263-3.124,0.53-4.683,0.797c-0.098,0.016-0.396,0.074-0.694,0.136
   c-0.29,0.062-0.585,0.12-0.678,0.135l-0.766,0.132c-0.151-0.809-2.629-13.864-3.709-16.57c-0.708-1.781-1.908-2.698-2.733-3.147
   C172.051,22.705,179.851,21.138,187.882,19.631 M163.375,24.571l-0.004,0.016c0.09,0.023,2.187,0.604,3.202,3.143
   c1.065,2.676,3.65,16.338,3.678,16.473c0.162,0.906,0.271,2.47-0.089,3.008l-8.439,1.649c-0.187,0.035-0.311-0.038-0.318-0.077
   c0.213-1.061-0.082-2.652-0.094-2.722c-0.108-0.546-2.605-13.41-3.658-16.058c-0.755-1.897-2.113-3.005-2.911-3.519
   C157.596,25.837,160.475,25.199,163.375,24.571 M117.84,35.837c11.687-3.283,23.631-6.318,36.023-9.152l-0.012,0.027
   c0.024,0.012,2.219,1.038,3.206,3.527c0.933,2.346,3.128,13.399,3.554,15.571l-2.241,0.394c-1.557,0.279-3.113,0.558-4.669,0.841
   c-3.155,0.576-8.316,1.692-13.806,2.985l-5.311,1.242c-4.417,1.088-9.446,2.362-14.947,3.786c-0.67-3.275-2.529-12.543-2.68-14.812
   C116.803,37.935,117.611,36.259,117.84,35.837 M117.019,36.069c-0.348,0.809-0.829,2.3-0.701,4.22
   c0.186,2.799,2.815,15.516,2.927,16.058c0.016,0.066,0.353,1.634,0.844,2.544c0.023,0.043,0.015,0.081,0.004,0.108
   c-0.012,0.02-0.038,0.066-0.101,0.078l-5.958,1.235c-0.371-0.403-0.789-1.765-0.987-2.683c-0.027-0.132-2.73-13.213-2.915-15.97
   c-0.151-2.295,0.701-3.627,0.925-3.937C113.028,37.18,115.025,36.627,117.019,36.069 M86.679,44.958c0-0.12,0.074-0.228,0.167-0.263
   c7.294-2.335,14.68-4.359,21.827-6.318c0.495-0.136,0.995-0.275,1.494-0.411c-0.364,0.72-0.79,1.963-0.674,3.736
   c0.163,2.439,2.176,12.393,2.769,15.285c-12.521,3.298-23.384,6.283-25.583,6.891V44.958z M18.303,307.582
   c-0.032-4.719-0.059-9.439-0.082-14.162c-0.019-4.011-0.035-8.021-0.05-12.032l-0.012-4.916c0-0.791-0.012-1.58-0.023-2.37
   c-0.031-2.365-0.066-4.812,0.155-7.216c0.437-4.7,1.591-9.466,2.706-14.077l0.15-0.627c1.127-4.657,2.451-9.442,4.046-14.622
   c1.514-4.901,3.187-9.883,5.114-15.238c1.793-4.975,3.791-10.201,5.939-15.539c2.014-5.006,4.205-10.233,6.519-15.537
   c2.153-4.936,4.46-10.057,6.861-15.218c2.211-4.762,4.553-9.671,6.957-14.587c2.191-4.48,4.483-9.071,6.813-13.651
   c2.091-4.096,4.251-8.269,6.431-12.4c1.904-3.608,3.855-7.255,5.803-10.84c1.63-3.004,3.291-6.02,4.932-8.974
   c1.305-2.334,2.59-4.622,3.826-6.79c0.816-1.437,1.64-2.873,2.469-4.301c0.105-0.182,0.209-0.364,0.318-0.546
   c0.266,8.567,0.518,15.745,0.67,17.959c0.456,6.729,3.077,28.614,5.988,44.18l0.066-0.011l-0.066,0.015
   c0.031,0.159,0.636,4.251-5.973,31.785c-10.504,24.057-18.226,83.463-18.304,84.094c-0.004,0.19-0.267,14.026-2.033,33.031
   c-2.28,0.127-3.701,0.201-3.766,0.205c-0.209,0.012-21.321,1.297-45.393-0.36C18.345,312.417,18.322,309.998,18.303,307.582
    M18.62,338.394c-0.07-4.916-0.132-9.984-0.187-15.501c-0.026-2.469-0.042-4.943-0.061-7.413c9.419,0.646,18.386,0.844,25.822,0.844
   c11.591,0,19.474-0.48,19.601-0.488c0.062-0.004,1.444-0.073,3.667-0.201c-0.658,7.003-1.518,14.68-2.645,22.624
   c-0.302,2.118-0.569,4.553-0.809,7.247c-6.659,0.275-25.837,0.863-45.284-0.449C18.685,342.924,18.654,340.714,18.62,338.394
    M19.204,366.075c-0.123-3.868-0.228-7.987-0.332-12.965c-0.047-2.373-0.094-4.836-0.14-7.41c9.303,0.627,18.54,0.82,26.38,0.82
   c8.489,0,15.338-0.228,18.842-0.371c-0.643,7.514-1.061,16.961-1.324,27.208c-5.184,0.282-23.008,1.057-43.17-0.298
   C19.351,370.574,19.27,368.185,19.204,366.075 M20.284,383.856c-0.065-0.348-0.116-0.704-0.154-1.01
   c-0.272-2.087-0.388-4.235-0.5-6.311l-0.011-0.22c-0.047-0.879-0.09-1.75-0.128-2.614c8.741,0.585,17.046,0.771,24.072,0.771
   c9.118,0,16.082-0.314,19.047-0.472c-0.236,9.535-0.341,19.74-0.363,29.701c-7.453,0.317-23.07,0.712-40.363-0.464
   C21.744,396.171,21.271,388.943,20.284,383.856 M49.545,462.287c-15.424,0.306-25.629-4.204-27.011-4.855
   c-0.19-2.33-2.079-26.097-1.227-33.851c0.445-4.057,0.727-11.735,0.588-19.706c8.858,0.604,17.27,0.794,24.378,0.794
   c6.76,0,12.33-0.17,15.97-0.325c-0.055,28.269,0.546,54.416,0.619,57.591C58.824,462.078,54.438,462.19,49.545,462.287
    M97.778,404.328c-1.096,15.366-1.235,50.785-1.242,52.357c-0.102,0.232-1.243,2.249-10.221,3.45
   c-7.057,0.94-14.134,1.447-22.81,1.773c-0.077-3.206-0.678-29.35-0.623-57.591c2.516-0.113,3.956-0.209,4.007-0.213
   c0.216-0.012,21.571-0.991,31.086-2.555C97.91,402.482,97.844,403.411,97.778,404.328 M99.505,374.492
   c-0.449,9.635-0.937,18.311-1.487,26.398c-9.396,1.572-30.94,2.563-31.165,2.575c-0.053,0.004-1.478,0.097-3.967,0.209
   c0.023-9.965,0.128-20.174,0.367-29.713c0.585-0.031,0.906-0.054,0.929-0.054c0.259-0.016,25.9-1.44,35.49-3.02
   C99.613,372.099,99.559,373.303,99.505,374.492 M100.364,349.571c-0.097,7.011-0.367,13.984-0.666,20.662
   c-9.442,1.583-35.287,3.02-35.555,3.035c-0.027,0-0.329,0.019-0.875,0.054c0.264-10.255,0.686-19.701,1.329-27.2
   c1.196-0.05,1.866-0.089,1.904-0.089c0.244-0.012,24.27-1.057,33.875-2.621C100.391,345.456,100.395,347.519,100.364,349.571
    M101.042,315.433c-0.922,7.871-0.817,15.768-0.72,23.407c0.019,1.293,0.034,2.605,0.046,3.922
   c-9.492,1.567-33.65,2.62-33.897,2.632c-0.039,0-0.678,0.035-1.817,0.085c0.236-2.648,0.5-5.044,0.794-7.127
   c1.135-7.995,2.002-15.718,2.66-22.752c8.176-0.465,25.768-1.561,33.251-2.745C101.251,313.714,101.142,314.574,101.042,315.433
    M116.5,254.098c-4.1,1.692-5.61,6.628-6.546,11.247c-0.356,1.762-0.717,3.523-1.076,5.285c-2.769,13.565-5.621,27.556-7.434,41.563
   c-7.312,1.188-24.997,2.292-33.274,2.76c1.758-18.978,2.02-32.779,2.02-32.945c0.078-0.597,7.794-59.957,18.266-83.909l0.019-0.054
   c4.398-18.327,5.618-26.349,5.923-29.744l2.629,10.278c0.325,1.282,1.405,5.258,2.9,10.763
   C104.972,207.925,116.702,251.141,116.5,254.098 M122.915,287.01c-0.797-6.807-5.412-30.298-5.858-32.547
   c0.252-0.658-0.254-4.054-5.717-24.983c-3.542-13.584-7.906-29.666-10.797-40.305c-1.491-5.505-2.571-9.481-2.897-10.754
   l-3.185-12.47c-2.908-15.544-5.521-37.382-5.978-44.095c-0.159-2.331-0.429-10.167-0.713-19.338l-1.088-37.979
   c1.735-0.48,12.838-3.534,25.71-6.925c0.012,0.069,0.024,0.124,0.032,0.147c0.092,0.441,0.6,2.671,1.347,3.163l0.113,0.073
   l6.24-1.293c0.24-0.046,0.445-0.213,0.55-0.434c0.1-0.224,0.092-0.472-0.024-0.685c-0.445-0.828-0.774-2.354-0.778-2.369
   c-0.004-0.015-0.042-0.205-0.108-0.53c3.46-0.895,6.74-1.735,9.794-2.501c2.718,12.884,12.501,53.46,30.105,67.397l2.295,32.14
   l-41.73,4.766l0.268,2.327l0.034-0.004c-0.015,0.062-0.018,0.124-0.012,0.189l3.81,32.586c0.012,0.085,0.047,0.17,0.097,0.244
   c0.202,0.275,1.026,1.041,2.354,2.272c1.281,1.185,2.876,2.664,3.194,3.105c0.092,0.132,0.244,0.209,0.399,0.209
   c0.018,0,0.038,0,0.058-0.004l39.592-4.68c0.163-0.019,0.306-0.12,0.38-0.271c0.243-0.488,1.796-2.431,3.043-3.991
   c1.223-1.53,1.978-2.482,2.153-2.792c0.053-0.097,0.077-0.201,0.065-0.313l-2.718-23.213l20.972-2.397
   c1.668,13.918,5.42,47.557,7.669,67.715c0.84,7.51,1.49,13.329,1.781,15.884l-0.07,0.016l-41.444,4.471l-28.954,3.531l-0.093-1.134
   c-0.258-2.261-0.847-7.255-1.622-13.849c-1.378-11.695-3.263-27.707-5.002-42.813l-0.642,0.073
   c1.738,15.111,3.624,31.123,5.002,42.814c0.778,6.593,1.366,11.587,1.622,13.837l0.147,1.796l29.613-3.612l11.331-1.223
   c3.334,27.874,5.513,43.611,8.831,57.347c1.141,4.731,2.33,10.247,3.538,16.356c-4.603,0.759-9.524,1.471-14.874,2.149
   c-13.162,1.676-29.485,3.151-42.678,3.867C126.271,313.846,123.492,291.914,122.915,287.01 M129.446,338.759
   c-0.248-1.925-0.716-5.595-1.297-10.143c13.201-0.717,29.524-2.192,42.683-3.868c5.365-0.682,10.302-1.394,14.916-2.152
   c1.726,8.741,3.496,18.671,5.266,29.229c-5.448,0.956-10.999,1.799-16.392,2.485c-14.046,1.788-29.109,3.19-41.405,3.86
   C131.316,349.056,129.783,341.364,129.446,338.759 M133.348,358.805c12.292-0.674,27.329-2.076,41.355-3.86
   c5.4-0.685,10.96-1.534,16.415-2.49c1.486,8.905,2.969,18.25,4.417,27.7c-4.44,0.736-9.078,1.413-13.944,2.029
   c-13.577,1.726-29.423,3.174-42.423,3.875C137.414,377.968,135.215,367.755,133.348,358.805 M142.33,400.557
   c-0.038-0.174-1.305-5.919-3.027-13.863c12.996-0.704,28.815-2.153,42.369-3.871c4.87-0.623,9.511-1.297,13.96-2.037
   c1.502,9.841,2.966,19.787,4.355,29.469c-4.619,0.775-9.446,1.483-14.525,2.126c-15.277,1.943-27.855,3.143-39.547,3.782
   C143.948,407.286,142.369,400.716,142.33,400.557 M180.677,493.363c-13.546-0.391-21.227-2.977-21.828-3.318
   c-0.565-1.022-3.995-16.001-5.451-32.772c-0.851-9.821-4.47-27.467-7.343-40.479c11.679-0.638,24.239-1.839,39.488-3.775
   c5.079-0.646,9.915-1.359,14.533-2.132c5.776,40.366,10.209,75.964,10.666,79.657C198.531,493.103,188.214,493.583,180.677,493.363
    M211.369,490.409c-0.492-3.964-4.909-39.43-10.662-79.627c8.73-1.483,16.685-3.202,24.058-5.203
   c0.885,8.083,1.482,13.782,1.498,13.941c0.069,0.549,6.89,54.52,7.436,64.211C225.766,486.789,218.271,488.93,211.369,490.409"
      />
      <path
        fill="#E5E5E5"
        d="M313.973,150.164v1.382l-47.912-0.171c0.012-0.402,0.019-0.809,0.026-1.211H313.973z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.32"
        strokeMiterlimit="10"
        strokeDasharray="1.28,0.96"
        d="M266.801,477.277
   c0,0,32.981,9.728,74.7,0.271"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.32"
        strokeMiterlimit="10"
        strokeDasharray="1.28,0.96"
        d="M462.268,477.277
   c0,0-33.162,9.728-74.881,0.271"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        d="M364.533,128.888
   c0.149-0.046,0.302-0.094,0.458-0.144"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        x1="365.9"
        y1="128.446"
        x2="365.9"
        y2="128.446"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        d="M365.901,128.445
   c3.342-1.133,7.789-3.023,10.467-5.701c1.777-1.777,2.659-4.168,2.998-6.619c0.342-2.481,0.049-4.927,0.086-7.408
   c0.027-1.815,0.009-3.632,0.013-5.447c0.007-2.89,0.014-5.78,0.021-8.67c0.008-3.362,0.017-6.724,0.024-10.087
   c0.009-3.541,0.018-7.081,0.026-10.622c0.009-3.425,0.016-6.849,0.025-10.274c0.007-3.014,0.015-6.028,0.022-9.042
   c0.006-2.309,0.011-4.618,0.016-6.928c0.004-1.31,0.007-2.62,0.01-3.93v-0.085"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        d="M379.608,43.631
   c0.001-0.16,0.001-0.32,0.001-0.48"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        x1="366.057"
        y1="43.588"
        x2="366.056"
        y2="44.068"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        x1="366.055"
        y1="45.019"
        x2="366.055"
        y2="45.02"
      />
      <polyline
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        points="
   366.055,45.02 365.98,128.345 365.98,147.781 "
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        x1="365.98"
        y1="147.781"
        x2="365.98"
        y2="148.261"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        d="M281.366,18.729
   c0,0,75.305-15.467,166.189,0"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.32"
        strokeMiterlimit="10"
        strokeDasharray="0.96,0.96"
        d="M371.191,181.447
   c0.43-9.38,1.03-23.796,0.781-26.11c-0.373-3.477-5.084-5.698-7.28-5.043h-0.096c-2.195-0.655-6.906,1.566-7.28,5.043
   c-0.245,2.283,0.336,16.349,0.765,25.733"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.32"
        strokeMiterlimit="10"
        strokeDasharray="0.96,0.96"
        d="M359.362,171.631
   v-13.007c0-1.672,0.623-3.302,1.803-4.486c0.811-0.815,1.831-1.255,3.304-1.271"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.32"
        strokeMiterlimit="10"
        strokeDasharray="0.96,0.96"
        d="M369.888,171.745
   l-0.181-13.188c0-1.672-0.623-3.301-1.802-4.486c-0.812-0.814-1.83-1.255-3.304-1.27"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        x1="368.69"
        y1="128.871"
        x2="368.69"
        y2="149.403"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        d="M320.944,41.175
   c14.021,0.213,28.153,0.418,28.16,0.373"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        d="M278.092,40.076
   l7,0.33l8.354,0.339c0,0,4.96,0.08,11.919,0.188"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        x1="320.865"
        y1="23.311"
        x2="349.104"
        y2="23.019"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        d="M279.673,21.326
   c2.822,1.919,6.25,2.258,6.25,2.258h8.54l10.827-0.112"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        d="M423.328,23.643
   l10.679,0.054h9.032c0,0,3.408-0.631,6.548-2.033"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        d="M407.742,40.734
   l-52.525,0.864h-1.245l-0.673-0.783c-0.666-1.219-1.334-2.435-1.984-3.656c-0.864-1.626-1.229-3.509-1.072-5.342
   c0.147-1.714,0.817-3.005,1.652-4.452c0.502-0.87,1.004-1.74,1.507-2.61l0.722-1.313l1.093-0.141l52.525,0.264"
      />
      <polyline
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        points="
   450.829,40.293 443.495,40.293 434.571,40.293 423.242,40.479 "
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        d="M292.063,42.385
   c-4.409,23.157-10.491,48.165-20.848,73.081l-2.261-1.046"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        d="M271.215,115.465
   c0,0-1.487,2.826-3.036,3.987"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        d="M436.911,42.385
   c4.409,23.157,10.491,48.165,20.848,73.081l2.261-1.046"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        d="M457.759,115.465
   c0,0,1.488,2.826,3.036,3.987"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M384.32,391.612
   c0.204,0.027,0.41,0.054,0.618,0.081"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="0.01,0"
        x1="386.189"
        y1="391.846"
        x2="386.196"
        y2="391.847"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.271,1.26,0.01,0"
        d="
   M386.195,391.847c9.498,1.114,22.303,1.506,33.153,1.506c16.91,0,34.623-1.496,42.937-2.443"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M462.292,390.909
   c0.212-0.024,0.418-0.048,0.618-0.071"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M462.136,412.13
   c-0.199,0.024-0.405,0.049-0.619,0.074"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.234,1.223"
        d="
   M460.298,412.347c-8.285,0.957-24.679,2.596-40.936,2.596c-10.971,0-23.645-0.757-32.868-1.956"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M386.487,412.986
   c-0.207-0.027-0.413-0.054-0.617-0.082"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M462.523,414.066
   c-0.196,0.025-0.402,0.051-0.618,0.078"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        x1="460.686"
        y1="414.293"
        x2="460.68"
        y2="414.294"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.24,1.229"
        d="M460.68,414.294
   c-7.673,0.925-23.768,2.585-41.317,2.585c-11.699,0-23.235-0.607-32.868-1.95"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M386.487,414.928
   c-0.207-0.029-0.413-0.058-0.618-0.088"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M384.32,389.289
   c0.205,0.03,0.411,0.061,0.618,0.09"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        x1="386.148"
        y1="389.547"
        x2="386.156"
        y2="389.548"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.232,1.221"
        d="
   M386.155,389.548c9.786,1.314,21.5,1.871,33.193,1.871c18.457,0,35.495-1.906,42.943-2.827"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M462.293,388.592
   c0.214-0.026,0.419-0.052,0.617-0.077"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M462.91,353.672
   c-0.197,0.023-0.403,0.047-0.618,0.072"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        x1="461.062"
        y1="353.88"
        x2="461.055"
        y2="353.88"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.25,1.239"
        d="M461.055,353.88
   c-7.999,0.85-24.705,2.106-41.301,2.106c-12.257,0-25.928-1.152-35.97-2.609"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M383.776,353.376
   c-0.207-0.03-0.412-0.061-0.616-0.091"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M381.998,331.992
   c0.203,0.031,0.408,0.062,0.615,0.094"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        x1="383.831"
        y1="332.263"
        x2="383.837"
        y2="332.264"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.241,1.23"
        d="M383.837,332.264
   c10.292,1.452,24.05,2.311,36.112,2.311c17.21,0,34.923-1.532,43.112-2.507"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M463.068,332.067
   c0.212-0.025,0.418-0.05,0.617-0.075"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M381.998,329.67
   c0.204,0.034,0.409,0.069,0.615,0.103"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        x1="383.829"
        y1="329.969"
        x2="383.837"
        y2="329.97"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.242,1.231"
        d="M383.837,329.97
   c10.563,1.668,23.219,2.668,36.112,2.668c18.966,0,35.959-1.956,43.115-2.887"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M463.066,329.751
   c0.215-0.028,0.421-0.055,0.618-0.081"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M463.297,355.608
   c-0.193,0.024-0.399,0.05-0.618,0.076"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="0.01,0"
        x1="461.438"
        y1="355.825"
        x2="461.431"
        y2="355.826"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.262,1.251,0.01,0"
        d="
   M461.431,355.826c-7.264,0.796-23.702,2.095-41.677,2.095c-13.008,0-25.892-0.613-36.357-2.216"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M383.389,355.704
   c-0.207-0.032-0.412-0.063-0.617-0.096"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M266.63,391.225
   c0.204,0.03,0.41,0.059,0.617,0.088"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="0.01,0"
        x1="268.477"
        y1="391.481"
        x2="268.485"
        y2="391.482"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.252,1.241,0.01,0"
        d="
   M268.484,391.482c9.949,1.305,22.788,1.872,34.486,1.872c15.654,0,32.005-1.525,40.465-2.448"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M343.441,390.905
   c0.211-0.023,0.417-0.046,0.617-0.068"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M343.283,412.517
   c-0.199,0.023-0.405,0.046-0.618,0.07"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        x1="341.438"
        y1="412.72"
        x2="341.431"
        y2="412.721"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.246,1.235"
        d="
   M341.431,412.721c-8.417,0.896-24.381,2.216-39.613,2.216c-11.747,0-25.261-0.961-34.952-2.331"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M266.859,412.606
   c-0.207-0.029-0.413-0.059-0.616-0.088"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M343.283,414.453
   c-0.199,0.024-0.405,0.048-0.618,0.073"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        x1="341.438"
        y1="414.666"
        x2="341.43"
        y2="414.667"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.246,1.235"
        d="M341.43,414.667
   c-7.949,0.885-23.229,2.206-39.612,2.206c-12.515,0.001-24.844-0.792-34.953-2.324"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M266.859,414.548
   c-0.206-0.031-0.412-0.063-0.616-0.095"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M266.984,388.856
   c0.205,0.033,0.411,0.065,0.617,0.098"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        x1="268.819"
        y1="389.139"
        x2="268.827"
        y2="389.14"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.242,1.23"
        d="M268.827,389.14
   c10.177,1.512,21.639,2.278,34.144,2.278c17.084,0,32.277-1.451,40.125-2.361"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M343.098,389.057
   c0.212-0.024,0.418-0.049,0.618-0.072"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M345.607,352.898
   c-0.2,0.025-0.406,0.051-0.617,0.077"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        x1="343.759"
        y1="353.126"
        x2="343.752"
        y2="353.126"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.24"
        d="M343.752,353.126
   c-9.1,1.101-26.285,2.874-43.132,2.874c-11.488,0-24.696-1.259-34.141-2.624"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M266.472,353.375
   c-0.207-0.03-0.412-0.06-0.616-0.09"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M265.469,331.605
   c0.204,0.031,0.409,0.062,0.616,0.092"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        x1="267.297"
        y1="331.874"
        x2="267.304"
        y2="331.875"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.236,1.225"
        d="
   M267.304,331.875c10.247,1.461,23.704,2.653,35.732,2.653c17.013,0,34.709-1.489,43.109-2.462"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M346.151,332.065
   c0.212-0.024,0.418-0.048,0.617-0.072"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M264.694,329.282
   c0.204,0.034,0.409,0.068,0.615,0.102"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="0.01,0"
        x1="266.537"
        y1="329.582"
        x2="266.545"
        y2="329.583"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.255,1.243,0.01,0"
        d="
   M266.545,329.583c10.612,1.681,23.596,3.01,36.491,3.01c18.595,0,35.953-1.899,43.498-2.845"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M346.538,329.747
   c0.214-0.027,0.419-0.053,0.617-0.078"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M345.993,354.834
   c-0.199,0.026-0.405,0.053-0.617,0.08"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="0.01,0"
        x1="344.141"
        y1="355.072"
        x2="344.133"
        y2="355.073"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.257,1.245,0.01,0"
        d="
   M344.133,355.072c-8.652,1.085-25.494,2.863-43.513,2.863c-12.257,0-24.284-0.717-34.142-2.231"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        d="M266.473,355.704
   c-0.207-0.032-0.412-0.063-0.617-0.096"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        d="M420.892,189.108
   c0.014,17.257,0.014,41.26,0.127,58.508c3.697-0.016-0.006-3.112,0,0c13.436-0.601,29.696-0.214,43.408-0.179"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        d="M463.262,189.088
   c-12.159-0.144-25.322,0.63-37.323,0.243c-2.323-1.161-3.872-3.484-5.808-5.033c-1.161-10.453,0-21.293-0.397-31.726"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        d="M420.518,156.722
   c13.938,0.089,28.262,0.089,42.311,0"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        d="M311.119,191.818
   c0.099,13.149,0.001,34.492-0.07,47.103c-0.029,4.987-0.052,9.047-0.057,11.793l-5.101-0.037"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        d="M265.415,189.074
   l41.314,0.125c0.679-0.675,4.781-4.469,5.444-5.122l0.104-31.505"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        x1="311.494"
        y1="156.722"
        x2="266.192"
        y2="156.722"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        x1="269.151"
        y1="200.946"
        x2="265.174"
        y2="200.946"
      />
      <polyline
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        points="
   296.719,200.946 303.115,200.946 303.115,252.407 "
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        d="M294.31,195.697
   v36.936c0,0.245-0.234,0.444-0.522,0.444h-22.195c-0.288,0-0.522-0.199-0.522-0.444v-36.936"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        x1="271.116"
        y1="235.38"
        x2="271.116"
        y2="251.941"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        x1="294.31"
        y1="235.34"
        x2="294.31"
        y2="251.902"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        x1="306.773"
        y1="22.869"
        x2="306.773"
        y2="43.591"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        x1="318.903"
        y1="22.869"
        x2="318.903"
        y2="43.591"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        x1="409.162"
        y1="22.869"
        x2="409.162"
        y2="43.591"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.421"
        strokeMiterlimit="10"
        strokeDasharray="1.251,1.25"
        x1="421.293"
        y1="22.869"
        x2="421.293"
        y2="43.591"
      />
      <path
        fill="#010101"
        d="M464.43,186.489c-0.278-12.299-0.549-24.126-0.782-34.854c-0.093-4.487-0.182-8.784-0.263-12.842
   c-0.829-42-5.939-71.109-10.077-88.132c-0.875-3.593-1.227-7.359-1.042-11.2c0.276-5.78-0.27-11.389-0.778-15.075
   c-0.008-0.058-0.766-5.354-1.219-6.678l-0.004-0.016c-0.054-0.151-0.104-0.247-0.147-0.275l-0.093-0.058v-0.004h-0.008l-0.057-0.038
   l-0.036,0.019c-46.131-9.14-90.122-8.652-118.914-6.631c-29.999,2.105-50.166,6.267-51.873,6.627l-0.023-0.011l-0.046,0.027
   c-0.027,0.003-0.047,0.007-0.051,0.011l0.004,0.016l-0.065,0.039c-0.047,0.027-0.093,0.124-0.148,0.278l-0.011,0.028
   c-0.422,1.238-1.092,5.779-1.099,5.834c-0.477,3.256-1.03,8.254-0.965,13.581c0.07,5.772-0.518,11.432-1.75,16.817
   c-3.809,16.647-8.513,44.873-9.303,84.841c-0.27,13.76-0.646,30.24-1.045,47.684c-1.432,62.709-3.054,133.789-1.389,142.127
   c0.828,4.127,0.968,27.464,1.13,54.486c0.255,43.12,0.581,96.785,3.767,105.411l0.054,0.147l0.151,0.046
   c0.306,0.097,31.196,9.369,72.499,0.016c0.284-0.004,0.287-0.066,0.38-1.61c0.05-0.853,0.12-2.107,0.209-3.702
   c0.174-3.186,0.418-7.738,0.704-13.201c0.508-9.663,1.2-23.139,2.064-40.057c1.487-29.133,2.954-58.265,2.954-58.265
   c0.039-0.863,3.651-86.754,2.749-122.329c1.204-27.103,7.553-53.363,7.615-53.626l0.012-0.062
   c0.607-15.923,2.972-39.682,6.999-39.961c3.96,0.275,6.314,23.264,6.969,39.171c0,0.062-0.004,0.101-0.004,0.113h0.011
   c0.008,0.228,0.016,0.452,0.027,0.677l0.008,0.062c0.062,0.263,6.411,26.523,7.619,53.607
   c-0.906,35.594,2.706,121.485,2.745,122.348c0,0,1.467,29.132,2.954,58.265c0.863,16.918,1.556,30.394,2.063,40.057
   c0.287,5.463,0.531,10.015,0.705,13.201c0.088,1.595,0.159,2.849,0.209,3.702c0.096,1.544,0.1,1.606,0.379,1.61
   c13.825,3.128,26.485,4.173,37.216,4.173c21.339,0,35.082-4.123,35.283-4.189l0.152-0.046l0.057-0.147
   c3.187-8.626,3.508-62.287,3.768-105.403c0.158-27.026,0.302-50.367,1.126-54.494C467.489,320.266,465.863,249.194,464.43,186.489
    M465.154,249.291c-7.87,0.062-16.619,0.089-25.082,0.116c-6.911,0.02-14.05,0.043-20.562,0.085
   c0.016-0.379,0.012-0.983,0.004-1.943v-0.097h-0.004c-0.004-0.042-0.011-0.089-0.027-0.136c-0.22-22.426-0.162-47.095-0.104-60.44
   c0.263,0.24,0.542,0.5,0.856,0.786c1.439,1.324,3.236,2.973,3.569,3.45c0.097,0.143,0.267,0.228,0.449,0.228h0.003l39.644-0.151
   C464.33,210.155,464.787,230.36,465.154,249.291 M463.792,186.505c0.031,1.339,0.061,2.686,0.092,4.041l-39.588,0.155
   c-0.43-0.573-2.056-2.063-3.627-3.511c-1.116-1.022-2.262-2.079-2.517-2.389l-0.112-32.616l44.977-0.194
   C463.246,162.63,463.513,174.337,463.792,186.505 M463.006,151.352l-44.94,0.19c0.004-0.058,0.012-0.112,0.016-0.174
   c0.031-0.387,0.082-1.015,0.178-1.204h44.718C462.986,150.559,462.994,150.954,463.006,151.352 M452.684,50.812
   c3.256,13.384,7.109,34.258,9.005,63.007c-0.108-0.259-0.213-0.519-0.317-0.778c-0.113-0.275-0.225-0.55-0.333-0.829
   c-0.19-0.472-0.379-0.944-0.565-1.417c-0.143-0.367-0.291-0.731-0.43-1.099c-0.12-0.302-0.236-0.604-0.352-0.909
   c-7.355-19.087-13.317-40.84-18.165-66.232l1.177-0.024c4.444-0.062,8.08-0.089,8.888-0.096
   C451.663,45.295,452.026,48.102,452.684,50.812 M451.624,39.434c-0.035,0.79-0.046,1.576-0.038,2.362
   c-0.81,0.004-4.449,0.035-8.89,0.097l-6.209,0.112c-3.853,0.054-8.262,0.12-13.023,0.189V22.09l16.751,0.12
   c0.291,0,6.81,0.023,9.605-3.735C450.389,21.01,452.069,30.116,451.624,39.434 M331.057,11.343
   c28.675-2.013,72.453-2.505,118.383,6.55c-2.517,3.694-9.14,3.682-9.222,3.679l-75.693-0.539l-0.607,0.016l-75.431,0.747
   c-0.065,0-6.372-0.186-8.869-3.91C282.819,17.228,302.46,13.352,331.057,11.343 M422.817,22.086v21.932
   c0,0.375-0.303,0.681-0.678,0.681h-13.522c-0.376,0-0.682-0.306-0.682-0.681V21.982L422.817,22.086z M348.711,37.309
   c0.553,1.041,1.123,2.079,1.687,3.12c0.516,0.941,1.03,1.885,1.537,2.834c-8.741,0.007-19.066-0.101-30.858-0.329v-20.82
   l31.339-0.314l-3.12,5.405c-0.837,1.447-1.541,2.791-1.693,4.587C347.438,33.697,347.832,35.656,348.711,37.309 M320.43,22.117
   v21.901c0,0.375-0.306,0.681-0.681,0.681H306.23c-0.376,0-0.682-0.306-0.682-0.681v-21.75L320.43,22.117z M279.246,18.478
   c2.764,3.771,8.951,3.953,9.237,3.957l16.419-0.163v20.302c-4.643-0.117-8.939-0.232-12.687-0.341l-5.985-0.228
   c-4.308-0.136-8.134-0.201-8.947-0.213c0.078-1.545,0.108-3.101,0.09-4.665C277.267,28.633,278.727,20.801,279.246,18.478
    M275.607,54.095c0.863-3.775,1.405-7.681,1.638-11.664c0.751,0.011,4.61,0.077,8.962,0.212l1.212,0.047
   c-4.843,25.334-10.798,47.045-18.138,66.104c-0.116,0.298-0.233,0.6-0.349,0.902c-0.142,0.368-0.29,0.736-0.433,1.099
   c-0.186,0.473-0.371,0.945-0.562,1.413c-0.111,0.279-0.223,0.558-0.336,0.837c-0.066,0.162-0.132,0.329-0.202,0.492
   C269.188,86.747,272.665,66.956,275.607,54.095 M266.087,150.164h47.885v1.382l-47.912-0.171
   C266.072,150.973,266.08,150.566,266.087,150.164 M265.274,186.493c0.278-12.16,0.546-23.848,0.774-34.475l47.924,0.167
   l-0.112,32.616c-0.255,0.31-1.405,1.367-2.517,2.389c-1.575,1.448-3.197,2.938-3.627,3.511l-42.535-0.131
   C265.214,189.203,265.243,187.844,265.274,186.493 M265.171,191.208l42.585,0.132c0.182,0,0.352-0.085,0.453-0.228
   c0.333-0.477,2.126-2.126,3.569-3.45c0.31-0.286,0.589-0.542,0.849-0.786c-0.012,14.383-0.055,33.205-0.09,47.015
   c-0.019,8.942-0.034,15.961-0.034,18.698l-16.129-0.096v-19.319c0.047-0.174,0.074-0.356,0.074-0.542v-32.914h7.947v52.69h0.643
   v-53.333h-8.59v-5.245h-27.515v5.245h-3.944C265.049,196.435,265.108,193.81,265.171,191.208 M293.787,234.305h-22.195
   c-1.115,0-2.021-0.747-2.021-1.673v-38.164h26.237v38.164C295.809,233.558,294.902,234.305,293.787,234.305 M295.734,234.208v18.281
   l-20.247-0.124l-5.652,0.023v-18.021c0.472,0.36,1.084,0.581,1.757,0.581h22.195C294.553,234.948,295.247,234.661,295.734,234.208
    M264.973,199.718h3.96v32.914c0,0.361,0.097,0.697,0.264,0.999v18.761l-5.343,0.023
   C264.174,235.385,264.577,217.197,264.973,199.718 M340.518,488.129c-39.546,8.904-69.436,0.693-71.829,0
   c-2.311-6.701-3.078-38.071-3.423-71.362c12.04,1.998,24.778,2.68,36.55,2.68c19.009,0,35.489-1.773,42.427-2.644
   C342.648,448.184,340.758,485.001,340.518,488.129 M344.278,416.152c-11.096,1.398-47.487,5.219-79.02-0.035
   c-0.1-9.891-0.166-19.941-0.224-29.55c12.466,2.176,25.718,2.915,37.935,2.915c19.188,0,35.811-1.812,42.799-2.702
   C345.366,394.697,344.839,405.068,344.278,416.152 M346.519,371.844c-0.012,0.248-0.29,5.772-0.72,14.285
   c-11.289,1.445-48.698,5.42-80.769-0.213c-0.004-0.948-0.012-1.893-0.016-2.83c-0.053-9.012-0.104-17.614-0.181-25.234
   c11.683,1.971,24.115,2.66,35.779,2.66c20.794,0,39.144-2.187,46.48-3.19C346.763,366.08,346.531,371.627,346.519,371.844
    M347.12,356.672c-11.309,1.556-49.737,6.043-82.272,0.534l-0.019,0.12c-0.155-14.99-0.403-26.089-0.952-28.846
   c-0.055-0.267-0.105-0.6-0.152-0.995c12.904,2.374,26.662,3.171,39.315,3.171c21.293,0,39.441-2.253,45.086-3.031
   C347.773,338.763,347.41,348.914,347.12,356.672 M364.212,155.305c-4.456,1.185-6.334,23.073-7.007,34.336
   c-0.492-10.411-1.46-32.114-1.127-35.207c0.236-2.226,2.002-3.709,3.031-4.394c1.719-1.142,3.786-1.692,5.103-1.367V155.305z
    M364.212,148.015c-1.495-0.294-3.636,0.283-5.456,1.491c-1.939,1.293-3.12,3.019-3.317,4.862
   c-0.441,4.115,1.317,39.345,1.394,40.843l0.085-0.004c-0.012,0.237-0.02,0.438-0.024,0.593c-0.255,1.057-6.437,26.976-7.63,53.742
   c0.472,18.537-0.283,50.727-1.119,77.433c-8.772,1.215-49.79,6.271-84.485-0.151c-0.79-8.529-0.481-38.618,0.181-73.762
   l11.642-0.051l37.665,0.229v-0.326c0-2.465,0.016-9.697,0.034-19.023c0.035-13.999,0.078-33.163,0.094-47.615
   c0.611-0.573,1.002-0.96,1.13-1.138c0.062-0.085,0.093-0.182,0.093-0.283l0.112-32.802c0-0.066-0.012-0.128-0.038-0.19h0.038v-2.342
   h-48.509c0.078-3.72,0.152-7.301,0.221-10.716c0.163-8.258,0.492-16.008,0.949-23.263c0.31-0.747,0.619-1.502,0.925-2.257
   c0.112-0.279,0.225-0.561,0.337-0.84c0.185-0.465,0.372-0.933,0.557-1.402c0.147-0.375,0.294-0.751,0.442-1.126
   c0.112-0.287,0.221-0.573,0.333-0.863c9.728-25.207,15.009-49.605,18.199-66.337l4.131,0.155c3.755,0.108,8.057,0.225,12.706,0.344
   v0.802c0,0.731,0.592,1.328,1.328,1.328h13.519c0.731,0,1.328-0.597,1.328-1.328v-0.441c11.408,0.216,21.439,0.325,29.999,0.325
   c4.862,0,9.245-0.035,13.136-0.105V148.015z M364.529,43.151c-3.542,0.065-7.507,0.104-11.87,0.112
   c-0.557-1.053-1.126-2.099-1.699-3.143c-0.566-1.038-1.13-2.072-1.684-3.109c-0.821-1.545-1.188-3.38-1.038-5.165
   c0.143-1.664,0.813-2.942,1.61-4.32l3.311-5.73l10.77-0.109l0.604-0.011l42.756,0.302v20.46
   C389.662,42.709,375.272,42.949,364.529,43.151 M364.854,155.305v-6.655c1.32-0.275,3.329,0.279,5.002,1.39
   c1.033,0.685,2.795,2.168,3.035,4.394c0.322,3.004-0.581,23.581-1.084,34.293C371.088,177.24,369.194,156.459,364.854,155.305
    M460.377,488.129c-2.392,0.693-32.284,8.904-71.829,0c-0.237-3.116-2.119-39.716-3.709-71.036
   c11.583,1.773,23.646,2.388,34.807,2.388c20.909,0,38.656-2.156,44.157-2.899C463.459,449.942,462.696,481.416,460.377,488.129
    M463.807,415.935c-8.238,1.119-45.647,5.633-79.004,0.507c-0.565-11.145-1.095-21.587-1.498-29.562
   c11.897,1.936,24.433,2.602,36.043,2.602c21.079,0,39.101-2.191,44.684-2.946C463.973,396.094,463.908,406.09,463.807,415.935
    M464.051,383.094c-0.003,0.925-0.011,1.859-0.015,2.796c-8.471,1.149-47.2,5.822-80.766,0.34
   c-0.43-8.571-0.712-14.134-0.723-14.382c-0.008-0.213-0.237-5.61-0.562-14.143c12.462,2.091,25.656,2.792,37.773,2.792
   c22.071,0,40.565-2.331,44.479-2.865C464.16,365.309,464.105,373.993,464.051,383.094 M465.193,328.48
   c-0.55,2.738-0.798,13.686-0.952,28.505c-5.711,0.779-46.987,6.017-82.279,0.066c-0.294-7.827-0.666-18.16-1.022-29.519
   c12.837,2.373,26.488,3.171,39.008,3.171c22.899,0,42.005-2.656,45.385-3.156C465.29,327.919,465.244,328.229,465.193,328.48
    M465.402,326.893c-4.397,0.654-47.827,6.798-84.481-0.015c-0.836-26.69-1.591-58.834-1.12-77.359
   c-1.188-26.743-7.371-52.658-7.626-53.719c-0.007-0.186-0.019-0.434-0.031-0.732c0.14-2.814,1.816-36.67,1.386-40.7
   c-0.201-1.843-1.378-3.569-3.317-4.858c-1.782-1.185-3.869-1.762-5.359-1.51V43.786c10.708-0.202,24.983-0.442,42.435-0.709v0.941
   c0,0.731,0.595,1.328,1.328,1.328h13.522c0.732,0,1.325-0.597,1.325-1.328v-1.185c4.765-0.069,9.178-0.131,13.031-0.186l4.382-0.081
   c3.19,16.736,8.474,41.203,18.23,66.488c0.112,0.29,0.221,0.576,0.333,0.867c0.148,0.375,0.294,0.747,0.441,1.122
   c0.186,0.469,0.373,0.933,0.558,1.398c0.112,0.283,0.225,0.565,0.341,0.848c0.31,0.77,0.623,1.537,0.94,2.299l0.078-0.03
   c0.457,7.258,0.786,15.001,0.949,23.247c0.065,3.415,0.138,6.996,0.22,10.716h-44.773c-0.607,0-0.673,0.832-0.751,1.796
   c-0.012,0.175-0.026,0.353-0.046,0.515l0.054,0.004c-0.034,0.066-0.054,0.14-0.054,0.217l0.112,32.806
   c0.004,0.101,0.035,0.198,0.093,0.279c0.132,0.178,0.523,0.565,1.134,1.138c-0.062,13.689-0.131,40.139,0.128,63.541l0.004,0.326
   l0.321-0.004c6.597-0.039,13.859-0.062,20.883-0.085c8.467-0.027,17.22-0.055,25.09-0.117l-0.004-0.421
   C465.863,286.263,466.227,318.175,465.402,326.893"
      />
      <path
        fill="#010101"
        d="M358.692,28.366c-1.785,0-3.236,1.451-3.236,3.233c0,1.784,1.451,3.236,3.236,3.236
   c1.784,0,3.236-1.452,3.236-3.236C361.927,29.817,360.476,28.366,358.692,28.366z"
      />
      <path
        fill="#010101"
        d="M373.29,28.366c-1.784,0-3.236,1.451-3.236,3.233c0,1.784,1.452,3.236,3.236,3.236
   c1.785,0,3.236-1.452,3.236-3.236C376.526,29.817,375.075,28.366,373.29,28.366z"
      />
      <path
        fill="#010101"
        d="M90.403,48.102c-1.153,0-2.021,1.886-2.021,4.387c0,2.496,0.868,4.382,2.021,4.382
   c1.157,0,2.024-1.886,2.024-4.382C92.427,49.988,91.56,48.102,90.403,48.102z"
      />
      <path
        fill="#010101"
        d="M99.436,45.392c-1.154,0-2.021,1.886-2.021,4.386c0,2.497,0.867,4.383,2.021,4.383
   c1.157,0,2.024-1.886,2.024-4.383C101.46,47.278,100.593,45.392,99.436,45.392z"
      />
    </svg>
  );
}
